(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.Telescope = {}));
}(this, function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    //日志收集接口
    var SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/log_h5.gif"; //'http://test.qa.91jkys.com:9342/log.gif';
    var DEBUG_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/f2e/log.gif";
    var BEAT_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/beat.gif";
    var DURATION_SERVER_URL = (window.location.protocol === 'http:' ? 'http:' : 'https:') + "//frontlo-collection.91jkys.com/duration.gif";
    var CUSTOM_TOKEN_KEY = 'TRYCATCH_TOKEN';
    var SEND_TYPE = {
        SYNC: 'SYNC',
        ASYNC: 'ASYNC',
        UNLOAD: 'UNLOAD'
    };
    var ACTION_TYPE = {
        EVENT: 'EVENT',
        PAGE: 'PAGE',
        VIEW: 'VIEW',
        DURATION: 'DURATION',
        VIEW_DURATION: 'VIEW_DURATION'
    };
    var SAFETY_KEY = [
        'version',
        'custom',
        'actionType',
        'eventName',
        'pageId',
        'domId',
        'domClass',
        'domHref',
        'domName',
        'domTag',
        'domContent',
        'domPath',
        'trackId',
        'referrerId',
        'score',
        'startTime',
        'endTime',
        'durationTime',
        'channel',
        'netType',
        'debug',
        'seKeywords',
        'bizId',
        'isAutoTrack',
        'autoTrackId',
        //
        'contentId',
        'patientId',
        'doctorId',
        'skuId',
        'prescriptionId',
        'storeId',
        'inquiryId',
        'orderId',
        'activityId'
    ];

    function _isPlaceholder(a) {
      return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }

    var _isPlaceholder_1 = _isPlaceholder;

    /**
     * Optimized internal one-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */


    function _curry1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder_1(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }

    var _curry1_1 = _curry1;

    /**
     * Optimized internal two-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */


    function _curry2(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;

          case 1:
            return _isPlaceholder_1(a) ? f2 : _curry1_1(function (_b) {
              return fn(a, _b);
            });

          default:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) ? f2 : _isPlaceholder_1(a) ? _curry1_1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder_1(b) ? _curry1_1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }

    var _curry2_1 = _curry2;

    function _arrayFromIterator(iter) {
      var list = [];
      var next;

      while (!(next = iter.next()).done) {
        list.push(next.value);
      }

      return list;
    }

    var _arrayFromIterator_1 = _arrayFromIterator;

    function _includesWith(pred, x, list) {
      var idx = 0;
      var len = list.length;

      while (idx < len) {
        if (pred(x, list[idx])) {
          return true;
        }

        idx += 1;
      }

      return false;
    }

    var _includesWith_1 = _includesWith;

    function _functionName(f) {
      // String(x => x) evaluates to "x => x", so the pattern may not match.
      var match = String(f).match(/^function (\w*)/);
      return match == null ? '' : match[1];
    }

    var _functionName_1 = _functionName;

    function _has(prop, obj) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    var _has_1 = _has;

    // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    function _objectIs(a, b) {
      // SameValue algorithm
      if (a === b) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return a !== 0 || 1 / a === 1 / b;
      } else {
        // Step 6.a: NaN == NaN
        return a !== a && b !== b;
      }
    }

    var _objectIs_1 = typeof Object.is === 'function' ? Object.is : _objectIs;

    var toString = Object.prototype.toString;

    var _isArguments =
    /*#__PURE__*/
    function () {
      return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
      } : function _isArguments(x) {
        return _has_1('callee', x);
      };
    }();

    var _isArguments_1 = _isArguments;

    // cover IE < 9 keys issues


    var hasEnumBug = !
    /*#__PURE__*/
    {
      toString: null
    }.propertyIsEnumerable('toString');
    var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

    var hasArgsEnumBug =
    /*#__PURE__*/
    function () {

      return arguments.propertyIsEnumerable('length');
    }();

    var contains = function contains(list, item) {
      var idx = 0;

      while (idx < list.length) {
        if (list[idx] === item) {
          return true;
        }

        idx += 1;
      }

      return false;
    };
    /**
     * Returns a list containing the names of all the enumerable own properties of
     * the supplied object.
     * Note that the order of the output array is not guaranteed to be consistent
     * across different JS platforms.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Object
     * @sig {k: v} -> [k]
     * @param {Object} obj The object to extract properties from
     * @return {Array} An array of the object's own properties.
     * @see R.keysIn, R.values
     * @example
     *
     *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
     */


    var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ?
    /*#__PURE__*/
    _curry1_1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    /*#__PURE__*/
    _curry1_1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }

      var prop, nIdx;
      var ks = [];

      var checkArgsLength = hasArgsEnumBug && _isArguments_1(obj);

      for (prop in obj) {
        if (_has_1(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }

      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;

        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];

          if (_has_1(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }

          nIdx -= 1;
        }
      }

      return ks;
    });
    var keys_1 = keys;

    /**
     * Gives a single-word string description of the (native) type of a value,
     * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
     * attempt to distinguish user Object types any further, reporting them all as
     * 'Object'.
     *
     * @func
     * @memberOf R
     * @since v0.8.0
     * @category Type
     * @sig (* -> {*}) -> String
     * @param {*} val The value to test
     * @return {String}
     * @example
     *
     *      R.type({}); //=> "Object"
     *      R.type(1); //=> "Number"
     *      R.type(false); //=> "Boolean"
     *      R.type('s'); //=> "String"
     *      R.type(null); //=> "Null"
     *      R.type([]); //=> "Array"
     *      R.type(/[A-z]/); //=> "RegExp"
     *      R.type(() => {}); //=> "Function"
     *      R.type(undefined); //=> "Undefined"
     */


    var type =
    /*#__PURE__*/
    _curry1_1(function type(val) {
      return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
    });

    var type_1 = type;

    /**
     * private _uniqContentEquals function.
     * That function is checking equality of 2 iterator contents with 2 assumptions
     * - iterators lengths are the same
     * - iterators values are unique
     *
     * false-positive result will be returned for comparision of, e.g.
     * - [1,2,3] and [1,2,3,4]
     * - [1,1,1] and [1,2,3]
     * */


    function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
      var a = _arrayFromIterator_1(aIterator);

      var b = _arrayFromIterator_1(bIterator);

      function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
      } // if *a* array contains any element that is not included in *b*


      return !_includesWith_1(function (b, aItem) {
        return !_includesWith_1(eq, aItem, b);
      }, b, a);
    }

    function _equals(a, b, stackA, stackB) {
      if (_objectIs_1(a, b)) {
        return true;
      }

      var typeA = type_1(a);

      if (typeA !== type_1(b)) {
        return false;
      }

      if (a == null || b == null) {
        return false;
      }

      if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
        return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
      }

      if (typeof a.equals === 'function' || typeof b.equals === 'function') {
        return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
      }

      switch (typeA) {
        case 'Arguments':
        case 'Array':
        case 'Object':
          if (typeof a.constructor === 'function' && _functionName_1(a.constructor) === 'Promise') {
            return a === b;
          }

          break;

        case 'Boolean':
        case 'Number':
        case 'String':
          if (!(typeof a === typeof b && _objectIs_1(a.valueOf(), b.valueOf()))) {
            return false;
          }

          break;

        case 'Date':
          if (!_objectIs_1(a.valueOf(), b.valueOf())) {
            return false;
          }

          break;

        case 'Error':
          return a.name === b.name && a.message === b.message;

        case 'RegExp':
          if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
            return false;
          }

          break;
      }

      var idx = stackA.length - 1;

      while (idx >= 0) {
        if (stackA[idx] === a) {
          return stackB[idx] === b;
        }

        idx -= 1;
      }

      switch (typeA) {
        case 'Map':
          if (a.size !== b.size) {
            return false;
          }

          return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

        case 'Set':
          if (a.size !== b.size) {
            return false;
          }

          return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
          break;

        default:
          // Values of other types are only equal if identical.
          return false;
      }

      var keysA = keys_1(a);

      if (keysA.length !== keys_1(b).length) {
        return false;
      }

      var extendedStackA = stackA.concat([a]);
      var extendedStackB = stackB.concat([b]);
      idx = keysA.length - 1;

      while (idx >= 0) {
        var key = keysA[idx];

        if (!(_has_1(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
          return false;
        }

        idx -= 1;
      }

      return true;
    }

    var _equals_1 = _equals;

    /**
     * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
     * cyclical data structures.
     *
     * Dispatches symmetrically to the `equals` methods of both arguments, if
     * present.
     *
     * @func
     * @memberOf R
     * @since v0.15.0
     * @category Relation
     * @sig a -> b -> Boolean
     * @param {*} a
     * @param {*} b
     * @return {Boolean}
     * @example
     *
     *      R.equals(1, 1); //=> true
     *      R.equals(1, '1'); //=> false
     *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
     *
     *      const a = {}; a.v = a;
     *      const b = {}; b.v = b;
     *      R.equals(a, b); //=> true
     */


    var equals =
    /*#__PURE__*/
    _curry2_1(function equals(a, b) {
      return _equals_1(a, b, [], []);
    });

    var equals_1 = equals;

    /**
     *判断promise
     *
     * @export
     * @param {*} f
     * @returns
     */
    function isThenable(f) {
        return f && typeof f.then === 'function';
    }
    /**
     *获取url参数 兼容微信支付 window.location.search改成window.location.href
     *
     * @export
     * @param {string} variable
     * @returns
     */
    function getQueryVariable(variable) {
        var query = window.location.href.match(/\?(.*)$/);
        if (!query)
            return null;
        var vars = query[1].split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return null;
    }
    /**
     *获取cookie
     *
     * @export
     * @param {string} name
     * @returns
     */
    function getCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i in cookies) {
            var arr = cookies[i].split('=');
            if (name == arr[0].trim()) {
                return unescape(arr[1]).replace(/&&&&/g, ';');
            }
        }
        return null;
    }
    /**
     *设置cookie
     *
     * @export
     * @param {string} name
     * @param {string} value
     * @param {number} [expires=99999]
     * @param {string} [path='/']
     * @param {string} [domain]
     */
    function setCookie(name, value, expires, path, domain) {
        if (expires === void 0) { expires = 99999; }
        if (path === void 0) { path = '/'; }
        document.cookie =
            name +
                '=' +
                value.replace(/;/g, '&&&&') +
                (expires ? '; expires=' + getExpires(expires) : '') +
                (path ? '; path=' + path : '') +
                ('; domain=' + (domain ? domain : '.' + location.host.replace(/.*\.(.*\..*)$/, '$1')));
        function getExpires(hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            return date.toUTCString();
        }
    }
    /**
     *
     *
     * @export
     * @param {*} binding
     * @returns
     */
    function notChanged(binding) {
        if (binding.oldValue !== undefined) {
            if (typeof binding.value === 'object') {
                return equals_1(binding.value, binding.oldValue);
            }
            else {
                return binding.value === binding.oldValue;
            }
        }
        else {
            return false;
        }
    }
    /**
     * if the binding value is empty
     */
    function isEmpty(binding) {
        return binding.value === '' || binding.value === undefined || binding.value === null;
    }
    function setFlag(key, value) {
        if (value === void 0) { value = true; }
        _TrackerGlobalData._trackerFlag = _TrackerGlobalData._trackerFlag || {};
        _TrackerGlobalData._trackerFlag[key] = value;
    }
    function getFlag(key) {
        _TrackerGlobalData._trackerFlag = _TrackerGlobalData._trackerFlag || {};
        return _TrackerGlobalData._trackerFlag[key] || false;
    }
    function getUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    /**
     *获取dom path
     *
     * @export
     * @param {HTMLElement} dom
     * @returns
     */
    function getDomPath(dom) {
        // let path = [dom.id ? '#' + dom.id : dom.tagName.toLowerCase()];
        var path = [];
        if (dom.id && typeof dom.id === 'string') {
            path.push('#' + dom.id);
        }
        else if (dom.className && typeof dom.className === 'string') {
            path.push(dom.tagName.toLowerCase() + '.' + dom.className.split(' ')[0]);
        }
        else {
            path.push(dom.tagName.toLowerCase());
        }
        while (dom.parentNode &&
            dom.parentNode.tagName &&
            dom.parentNode.tagName !== 'BODY' &&
            !dom.id) {
            dom = dom.parentNode;
            if (dom.id && typeof dom.id === 'string') {
                path.unshift('#' + dom.id);
            }
            else if (dom.className && typeof dom.className === 'string') {
                path.unshift(dom.tagName.toLowerCase() + '.' + dom.className.split(' ')[0]);
            }
            else {
                path.unshift(dom.tagName.toLowerCase());
            }
        }
        return path.join('>');
    }
    function getLocationHref() {
        if (typeof document === 'undefined' || document.location == null)
            return '';
        return document.location.href;
    }
    function isObject(o) {
        return Object.prototype.toString.call(o) === '[object Object]';
    }
    function hashCode(str) {
        var hash = 0;
        if (!str || str.length === 0) {
            return '';
        }
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
        return String(hash).replace('-', '0');
    }
    function getRealPath(url, offlineUrl) {
        if (/file:/.test(url) && offlineUrl) {
            url = offlineUrl + url.replace(/^.*(#.*)$/, '$1');
        }
        return url
            .replace('https', 'http')
            .replace(/\?.*$/, '')
            .replace(/\/\d+([\/]*$)/, '{param}$1')
            .replace(/index\.html/, '')
            .replace(/www\./, '')
            .trim();
    }
    var inMin = /miniprogram/i.test(window.navigator.userAgent);
    var inWechat = !inMin && /micromessenger/i.test(window.navigator.userAgent);

    var getReferrerId = function () {
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
                return urlInfo.referrerId;
            }
            catch (error) { }
        }
        try {
            var referrerId = getQueryVariable('referrer_id');
            if (referrerId) {
                return referrerId;
            }
            else {
                var referrerInfo = JSON.parse(localStorage.getItem('referrer_id'));
                return referrerInfo ? referrerInfo.referrerId : null;
            }
        }
        catch (error) {
            return null;
        }
    };
    var setReferrerId = function (type) {
        try {
            var pageInfo_1 = getPageInfo();
            var referrerInfo = JSON.parse(localStorage.getItem('referrer_id')) || {
                pageId: pageInfo_1.pageId,
                referrerId: '',
                date: Date.now()
            };
            switch (type) {
                case 'UPDATE': //置空
                    referrerInfo.date = Date.now();
                    referrerInfo.referrerId = referrerInfo.date + 5000 > Date.now() ? referrerInfo.pageId : '';
                    referrerInfo.pageId = '';
                    break;
                case 'BEAT': //
                    referrerInfo.pageId = pageInfo_1.pageId;
                    referrerInfo.date = Date.now();
                    break;
            }
            localStorage.setItem('referrer_id', JSON.stringify(referrerInfo));
            setPageInfo({});
        }
        catch (error) { }
    };
    var getSourceEventId = function () {
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
                return urlInfo.sourceEventId;
            }
            catch (error) { }
        }
        try {
            var sourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            if (sourceEventInfo.date + 5000 > Date.now()) {
                return sourceEventInfo.sourceEventId;
            }
            return null;
        }
        catch (e) {
            return null;
        }
    };
    var setSourceEventId = function (type, data) {
        var preSourceEventInfo = null;
        try {
            preSourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            switch (type) {
                case 'UPDATE': //置空
                    preSourceEventInfo = {
                        sourceEventId: preSourceEventInfo && preSourceEventInfo.date + 5000 > Date.now() ? preSourceEventInfo.recentId : '',
                        recentId: (preSourceEventInfo && preSourceEventInfo.recentId) || '',
                        date: Date.now(),
                        isAutoTrack: false,
                        url: location.href
                    };
                    localStorage.setItem('source_event_id', JSON.stringify(preSourceEventInfo));
                    break;
                case 'RECORD': //记录
                    if (data && data.actionType === ACTION_TYPE.EVENT && !data.debug) {
                        if (!preSourceEventInfo || preSourceEventInfo.isAutoTrack || preSourceEventInfo.date < Date.now() - 500) {
                            localStorage.setItem('source_event_id', JSON.stringify({
                                date: Date.now(),
                                isAutoTrack: data.isAutoTrack,
                                url: location.href,
                                sourceEventId: preSourceEventInfo ? preSourceEventInfo.sourceEventId : '',
                                recentId: data.trackId
                            }));
                        }
                    }
                    break;
            }
            setPageInfo({});
        }
        catch (error) { }
    };
    var pageInfo = {
        pageId: null,
        referrerId: getReferrerId(),
        sourceEventId: getSourceEventId(),
        referrerUrl: document.referrer || '',
        url: location.href,
        host: location.host,
        path: location.pathname,
        hash: location.hash,
        title: document.title || ''
    };
    var setPageInfo = function (info) {
        if (info.sourceEventId) {
            localStorage.setItem('source_event_id', JSON.stringify({
                date: Date.now(),
                isAutoTrack: false,
                url: '',
                sourceEventId: info.sourceEventId,
                recentId: info.sourceEventId
            }));
        }
        if (info.referrerId) {
            localStorage.setItem('referrer_id', JSON.stringify({
                pageId: info.referrerId,
                referrerId: info.referrerId,
                date: Date.now()
            }));
        }
        pageInfo = __assign(__assign(__assign({}, pageInfo), { url: location.href, host: location.host, path: location.pathname, hash: location.hash, title: document.title || '', referrerId: getReferrerId(), sourceEventId: getSourceEventId() }), info);
    };
    var getPageInfo = function () {
        return __assign({}, pageInfo);
    };

    //default config
    var config = {
        trackKey: '1f003e7e36e93a0f3954aa466b8acfcf079f3b59d55c258e64113befe292e451',
        serverUrl: SERVER_URL,
        debugServerUrl: DEBUG_SERVER_URL,
        beatServerUrl: BEAT_SERVER_URL,
        durationServerUrl: DURATION_SERVER_URL,
        version: null,
        offlineUrl: '',
        sendType: SEND_TYPE.ASYNC,
        delayTime: 50,
        autoTrackPage: true,
        autoTrackClick: true,
        autoInstall: true,
        delayLink: false,
        delayLinkTime: 300,
        deviceIdKey: CUSTOM_TOKEN_KEY,
        beforeGenerateLog: null,
        autoTrackPrefix: 'zhiyun-',
        localGenerateDeviceId: true,
        routeChangeAfter: null,
        sendBeat: true
    };
    //script tracker-key  config
    var scriptDom = document.querySelector('script[track-key]') || document.querySelector('script[trackKey]');
    if (scriptDom) {
        var trackKey = scriptDom.getAttribute('track-key') || scriptDom.getAttribute('trackKey') || '';
        if (trackKey) {
            config.trackKey = trackKey;
        }
        var autoTrackPrefix = scriptDom.getAttribute('auto-track-prefix');
        if (autoTrackPrefix) {
            config.autoTrackPrefix = autoTrackPrefix;
        }
    }
    function getConfig() {
        return config;
    }
    function setConfig(data) {
        config = __assign(__assign({}, config), data);
    }

    function getDeviceId() {
        var config = getConfig();
        var deviceId = getCookie(config.deviceIdKey) ||
            localStorage.getItem(config.deviceIdKey) ||
            (config.localGenerateDeviceId ? getUUID() : null);
        if (deviceId) {
            setCookie(config.deviceIdKey, deviceId);
            localStorage.setItem(config.deviceIdKey, deviceId);
        }
        return deviceId;
    }
    var clientInfo = {
        clientWidth: window.screen.height,
        clientHeight: window.screen.width,
        radio: window.devicePixelRatio || 1,
        domain: document.domain || '',
        appId: 'H5',
        appVersion: null,
        appType: 'H5',
        marketId: null,
        sessionId: getUUID(),
        channel: null,
        deviceId: getDeviceId()
    };
    var setClientInfo = function (info) {
        //小程序
        var urlInfoStr = getQueryVariable('telescope-info');
        var urlInfo = {};
        if (urlInfoStr) {
            try {
                urlInfo = JSON.parse(decodeURIComponent(urlInfoStr));
            }
            catch (error) { }
        }
        // cookie 缓存
        var cookieInfoStr = getCookie('TELESCOPE_CACHE_INFO') || window.localStorage.getItem('TELESCOPE_CACHE_INFO');
        var cookieInfo = {};
        if (cookieInfoStr) {
            try {
                cookieInfo = JSON.parse(cookieInfoStr);
            }
            catch (error) { }
        }
        if (cookieInfo.expired && cookieInfo.expired < Date.now()) {
            // 30分钟过期
            cookieInfo.channel = null;
            cookieInfo.sessionId = getUUID();
        }
        delete cookieInfo.expired;
        var channel = getQueryVariable('channel') || urlInfo.channel || cookieInfo.channel || null;
        clientInfo = __assign(__assign(__assign(__assign(__assign({}, clientInfo), cookieInfo), urlInfo), { channel: channel }), info);
        // 兼容小程序ua不准 没法判断是否是小程序
        if (/_mini_/.test(clientInfo.appId)) {
            clientInfo.appType = 'MINI';
        }
        if (clientInfo.deviceId) {
            var config_1 = getConfig();
            setCookie(config_1.deviceIdKey, clientInfo.deviceId);
            localStorage.setItem(config_1.deviceIdKey, clientInfo.deviceId);
        }
        else {
            clientInfo.deviceId = getDeviceId();
        }
        var cacheStr = JSON.stringify({
            appId: clientInfo.appId,
            appVersion: clientInfo.appVersion,
            marketId: clientInfo.marketId,
            channel: clientInfo.channel,
            sessionId: clientInfo.sessionId,
            deviceId: clientInfo.deviceId,
            expired: Date.now() + 30 * 60 * 1000
        });
        setCookie('TELESCOPE_CACHE_INFO', cacheStr);
        window.localStorage.setItem('TELESCOPE_CACHE_INFO', cacheStr);
    };
    if (inMin) {
        setClientInfo({
            appType: 'MINI'
        });
    }
    else if (inWechat) {
        setClientInfo({
            appId: 'wechat',
            appType: 'WECHAT'
        });
    }
    var getClientInfo = function () {
        setClientInfo({});
        return __assign({}, clientInfo);
    };

    var userInfo = {
        uid: null,
        isLogin: false
    };
    function setUserInfo(info) {
        userInfo = __assign(__assign({}, userInfo), info);
    }
    function getUserInfo() {
        return userInfo;
    }
    function login(info) {
        var newUserInfo = { isLogin: true };
        if (!info) {
            newUserInfo.uid = getCookie('user_id') || getCookie('wechat_uid');
            if (!newUserInfo.uid) {
                return;
            }
        }
        else {
            newUserInfo = __assign(__assign({}, newUserInfo), info);
        }
        setUserInfo(newUserInfo);
    }
    function logout() {
        setUserInfo({ uid: null, isLogin: false });
    }

    function http(data, url, cb) {
        if (cb === void 0) { cb = function () { }; }
        var dataStr = data;
        var config = getConfig();
        url = (url || config.serverUrl) + "?" + (config.trackKey ? "trackKey=" + config.trackKey + "&k=" + config.trackKey + "&" : 'deb=true&') + "time=" + Date.now();
        //使用sendBeacon 出现重复提交
        if (window.location.protocol === 'https:' &&
            typeof window.navigator.sendBeacon === 'function' &&
            typeof Blob === 'function') {
            var headers = {
                type: 'text/plain; charset=UTF-8'
            };
            var blob = new Blob([dataStr], headers);
            var success = window.navigator.sendBeacon(url, blob);
            if (success) {
                cb();
                return;
            }
        }
        if (dataStr.length > 2000) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener('readystatechange', function () {
                if (this.readyState === 4) {
                    cb();
                }
            });
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            xhr.withCredentials = true;
            xhr.send(dataStr);
        }
        else {
            var img = new Image();
            img.onload = function () {
                cb();
            };
            img.src = url + "&data=" + encodeURIComponent(dataStr);
        }
    }

    var libInfo = {
        libVersion: '2.2.6',
        libType: 'js'
    };

    function getNetInfo () {
        var connection = window.navigator.connection ||
            window.navigator.mozConnection ||
            window.navigator.webkitConnection ||
            {};
        if (!connection) {
            return {};
        }
        var type = connection.type || connection.effectiveType;
        if (!type) {
            return {};
        }
        return {
            netType: type
        };
    }

    var DurationTime = /** @class */ (function () {
        function DurationTime() {
            this.startTime = Date.now();
            this.endTime = Date.now();
            this.config = null;
            this.timeMap = {};
        }
        DurationTime.getInstance = function () {
            if (!DurationTime.instance) {
                DurationTime.instance = new DurationTime();
            }
            return DurationTime.instance;
        };
        DurationTime.prototype.start = function (info) {
            if (!info.trackId || this.timeMap[info.trackId]) {
                return;
            }
            this.timeMap[info.trackId + hashCode(JSON.stringify(info.custom))] = __assign({ startTime: Date.now() }, info);
        };
        DurationTime.prototype.beat = function (key) {
            var logs = [];
            if (key) {
                if (typeof key !== 'string') {
                    key = key.trackId + hashCode(JSON.stringify(key.custom));
                }
                if (this.timeMap[key]) {
                    logs.push({
                        id: this.timeMap[key].id,
                        durationTime: Date.now() - this.timeMap[key].startTime
                    });
                }
                return logs;
            }
            for (var key_1 in this.timeMap) {
                if (!this.timeMap[key_1]) {
                    continue;
                }
                logs.push({
                    id: this.timeMap[key_1].id,
                    durationTime: Date.now() - this.timeMap[key_1].startTime
                });
            }
            return logs;
        };
        DurationTime.prototype.end = function (key) {
            var logs = [];
            if (key) {
                if (typeof key !== 'string') {
                    key = key.trackId + hashCode(JSON.stringify(key.custom));
                }
                if (this.timeMap[key]) {
                    logs.push(this.generateLog(this.timeMap[key]));
                    this.timeMap[key] = null;
                }
                return logs;
            }
            for (var key_2 in this.timeMap) {
                if (!this.timeMap[key_2]) {
                    continue;
                }
                logs.push(this.generateLog(this.timeMap[key_2]));
                this.timeMap[key_2] = null;
            }
            return logs;
        };
        DurationTime.prototype.generateLog = function (info) {
            var log = __assign(__assign({}, info), { actionType: info.actionType === ACTION_TYPE.PAGE ? ACTION_TYPE.DURATION : ACTION_TYPE.VIEW_DURATION, durationTime: Date.now() - info.startTime, trackTime: Date.now(), masterId: info.id, trackId: '', pageId: info.actionType === ACTION_TYPE.PAGE ? info.trackId : info.pageId, id: getUUID() });
            return log;
        };
        DurationTime.instance = null;
        return DurationTime;
    }());
    var instance = DurationTime.getInstance();

    /**
     * Returns a partial copy of an object containing only the keys specified. If
     * the key does not exist, the property is ignored.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Object
     * @sig [k] -> {k: v} -> {k: v}
     * @param {Array} names an array of String property names to copy onto a new object
     * @param {Object} obj The object to copy from
     * @return {Object} A new object with only properties from `names` on it.
     * @see R.omit, R.props
     * @example
     *
     *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
     *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
     */


    var pick =
    /*#__PURE__*/
    _curry2_1(function pick(names, obj) {
      var result = {};
      var idx = 0;

      while (idx < names.length) {
        if (names[idx] in obj) {
          result[names[idx]] = obj[names[idx]];
        }

        idx += 1;
      }

      return result;
    });

    var pick_1 = pick;

    var businessExtension = {
        seKeywords: getQueryVariable('seKeywords'),
        bizId: getQueryVariable('bizId')
    };
    var getBusinessExtension = function () {
        return __assign({}, businessExtension);
    };
    var setBuinessExtension = function (extension) {
        businessExtension = __assign(__assign({}, businessExtension), extension);
    };

    function sendInfo() {
        var clientInfo = getClientInfo();
        if (clientInfo.appId === 'H5') {
            return;
        }
        var pageInfo = getPageInfo();
        var sourceEventId = null;
        try {
            var sourceEventInfo = JSON.parse(localStorage.getItem('source_event_id'));
            sourceEventId = sourceEventInfo && sourceEventInfo.date + 5000 > Date.now() ? sourceEventInfo.recentId : '';
        }
        catch (error) { }
        var ua = window.navigator.userAgent;
        if (/miniprogram/i.test(ua)) {
            try {
                if (window.wx && window.wx.miniProgram) {
                    window.wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            window.wx.miniProgram.postMessage({
                                data: {
                                    type: 'TELESCOPE_INFO',
                                    data: { referrerId: pageInfo.pageId, sourceEventId: sourceEventId, channel: clientInfo.channel }
                                }
                            });
                        }
                    });
                }
                else {
                    var script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.onload = function () {
                        if (window.wx && window.wx.miniProgram) {
                            window.wx.miniProgram.getEnv(function (res) {
                                if (res.miniprogram) {
                                    window.wx.miniProgram.postMessage({
                                        data: {
                                            type: 'TELESCOPE_INFO',
                                            data: { referrerId: pageInfo.pageId, sourceEventId: sourceEventId, channel: clientInfo.channel }
                                        }
                                    });
                                }
                            });
                        }
                    };
                    script.src = '//static.91jkys.com/attachment/20210316204652605_db936fce9cf540e89ae70226ea953f44.js';
                    document.body.appendChild(script);
                }
            }
            catch (error) { }
        }
        if (typeof Sailer !== 'undefined' && /AppInfo|tangyi/.test(ua) && /zhiyun_patient/.test(ua)) {
            Sailer.nativeCall('sendEventInfo', {
                referrerId: pageInfo.pageId,
                channel: clientInfo.channel,
                sourceEventId: sourceEventId
            });
        }
    }

    var allData = [];
    var allDebugData = [];
    var allDurationData = [];
    var timer = null;
    // const uuid = getUUID();
    // let index = 0;
    /**
     * 同步发送
     * @param data
     */
    function send(data) {
        var config = getConfig();
        var sendType = config.sendType;
        if (data.actionType === 'PAGE' ||
            data.actionType === 'VIEW' ||
            data.actionType === 'DURATION' ||
            data.actionType === 'VIEW_DURATION') {
            sendDurationLog(data);
            return;
        }
        if (sendType === SEND_TYPE.SYNC) {
            sendSync(data);
        }
        else if (sendType === SEND_TYPE.ASYNC) {
            sendAsync(data);
        }
    }
    // 发送曝光&&时长
    function sendDurationLog(data) {
        var config = getConfig();
        if (data) {
            var newData = _generateData(data, config)[0];
            if (!newData) {
                return;
            }
            allDurationData.push(newData);
        }
        if (config.sendType === SEND_TYPE.SYNC || data.actionType === 'DURATION' || data.actionType === 'VIEW_DURATION') {
            sendSync();
        }
        else if (config.sendType === SEND_TYPE.ASYNC) {
            sendAsync();
        }
    }
    // 立即发送时长
    function sendQuick(data) {
        sendSync(); //立即发送普通日志
        var config = getConfig();
        sendToServer(data, config.durationServerUrl);
    }
    // 发送时长心跳
    function sendBeat(data) {
        sendSync(); //立即发送普通日志
        var config = getConfig();
        if (!data.length) {
            return;
        }
        return http(JSON.stringify(data), config.beatServerUrl);
    }
    function sendSync(data) {
        var config = getConfig();
        if (data) {
            var _a = _generateData(data, config), newData = _a[0], debug = _a[1];
            if (!newData) {
                return;
            }
            if (debug) {
                allDebugData.push(newData);
            }
            else {
                allData.push(newData);
            }
        }
        clearTimeout(timer);
        sendToServer(allDurationData, config.durationServerUrl);
        sendToServer(allData);
        sendToServer(allDebugData, config.debugServerUrl);
        allDurationData.length = 0;
        allData.length = 0;
        allDebugData.length = 0;
    }
    /**
     * 延迟发送  data不存在则马上发送本地allData
     * @param data
     */
    function sendAsync(data) {
        var config = getConfig();
        if (data) {
            var _a = _generateData(data, config), newData = _a[0], debug = _a[1];
            if (!newData) {
                return;
            }
            if (debug) {
                allDebugData.push(newData);
            }
            else {
                allData.push(newData);
            }
        }
        clearTimeout(timer);
        // 无参数或者大于10条发送发送
        if ((!data && allData.length > 0) || allData.length >= 10 || allDebugData.length >= 10) {
            sendSync();
            return;
        }
        timer = setTimeout(function () {
            sendSync();
        }, config.delayTime);
    }
    /**
     * 发送到服务器
     * @param data
     * @param isAjax
     */
    function sendToServer(data, url) {
        if (!data || !data.length) {
            return;
        }
        return http(JSON.stringify(_wrapperData(data)), url);
    }
    /**
     * 合并其他信息
     * @param data
     */
    function _wrapperData(data) {
        var config = getConfig();
        // index++;
        var wrapperData = __assign(__assign(__assign(__assign({ customTime: Date.now(), items: data }, getClientInfo()), libInfo), getUserInfo()), { version: config.version });
        return wrapperData;
    }
    /**
     * 补充埋点信息
     * @param data
     * @param config
     */
    function _generateData(data, config) {
        // index++;
        if (typeof config.beforeGenerateLog === 'function') {
            data = config.beforeGenerateLog(data);
            if (!data) {
                return [null, !!data.debug];
            }
        }
        //序列化自定义
        if (isObject(data.custom)) {
            data.custom = JSON.stringify(data.custom);
        }
        if (typeof data.custom === 'string' && data.custom.length > 800) {
            data.custom = data.custom.substr(0, 800) + '[超出800部分被裁剪]';
        }
        var newData = pick_1(SAFETY_KEY, data);
        var pageInfo = getPageInfo();
        var netInfo = getNetInfo();
        setBuinessExtension({
            seKeywords: getQueryVariable('seKeywords'),
            bizId: getQueryVariable('bizId')
        });
        var businessInfo = getBusinessExtension();
        if (data.actionType === ACTION_TYPE.PAGE) {
            //修改当前pageInfo
            setPageInfo({
                pageId: data.trackId || ''
            });
            setReferrerId('BEAT');
            // setSourceEventId('UPDATE');
            pageInfo = getPageInfo();
            pageInfo.pageId = null;
        }
        if (data.actionType === ACTION_TYPE.EVENT) {
            setSourceEventId('RECORD', data);
            pageInfo = getPageInfo();
        }
        var uuid = getUUID();
        var result = __assign(__assign(__assign(__assign(__assign({}, newData), pageInfo), netInfo), businessInfo), { trackTime: Date.now(), id: uuid });
        if (!data.debug) {
            window._TELESCOPE_LOG_ID = uuid;
            if (result.actionType === ACTION_TYPE.PAGE) {
                var durationLogs = instance.end();
                if (durationLogs && durationLogs.length) {
                    sendQuick(durationLogs);
                }
                instance.start(result);
            }
            if (result.actionType === ACTION_TYPE.VIEW) {
                instance.start(result);
            }
            sendInfo();
            // console.log(JSON.stringify(result, null, 2));
        }
        return [result, !!data.debug];
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var vissense = createCommonjsModule(function (module, exports) {
    /*! { "name": "vissense", "version": "0.10.0", "homepage": "https://vissense.github.io/vissense","copyright": "(c) 2016 tbk" } */
    !function(root, name, factory) {
        var withWindow = function(win) {
            var product = factory(win, win.document);
            return product.noConflict = function() {
                return product;
            }, product;
        };
        module.exports = function(win) {
            return withWindow(win);
        };
    }(commonjsGlobal, "VisSense", function(window, document, undefined$1) {
        function async(callback, delay) {
            return function() {
                var args = arguments;
                return defer(function() {
                    callback.apply(undefined$1, args);
                }, delay || 0);
            };
        }
        function debounce(callback, delay) {
            var cancel = noop;
            return function() {
                var self = this, args = arguments;
                cancel(), cancel = defer(function() {
                    callback.apply(self, args);
                }, delay);
            };
        }
        function defaults(dest, source) {
            var sourceIsObject = isObject(source), destIsObject = isObject(dest);
            return sourceIsObject || destIsObject ? sourceIsObject && destIsObject ? (forEach(Object.keys(source), function(property) {
                dest[property] === undefined$1 && (dest[property] = source[property]);
            }), dest) : sourceIsObject ? source : dest : source;
        }
        function defer(callback, delay) {
            var timer = setTimeout(function() {
                callback();
            }, delay || 0);
            return function() {
                clearTimeout(timer);
            };
        }
        function fireIf(when, callback) {
            return function() {
                return (isFunction(when) ? when() : when) ? callback() : undefined$1;
            };
        }
        function extend(dest, source, callback) {
            for (var index = -1, props = Object.keys(source), length = props.length, ask = isFunction(callback); ++index < length; ) {
                var key = props[index];
                dest[key] = ask ? callback(dest[key], source[key], key, dest, source) : source[key];
            }
            return dest;
        }
        function forEach(array, callback, thisArg) {
            for (var i = 0, n = array.length; n > i; i++) {
                var result = callback.call(thisArg, array[i], i, array);
                if (result !== undefined$1) return result;
            }
        }
        function identity(value) {
            return value;
        }
        function isDefined(value) {
            return value !== undefined$1;
        }
        function isArray(value) {
            return value && "object" == typeof value && "number" == typeof value.length && "[object Array]" === Object.prototype.toString.call(value) || !1;
        }
        function isElement(value) {
            return value && 1 === value.nodeType || !1;
        }
        function isFunction(value) {
            return "function" == typeof value || !1;
        }
        function isObject(value) {
            var type = typeof value;
            return "function" === type || value && "object" === type || !1;
        }
        function noop() {}
        function now() {
            return new Date().getTime();
        }
        function once(callback) {
            var cache, called = !1;
            return function() {
                return called || (cache = callback.apply(undefined$1, arguments), called = !0), cache;
            };
        }
        function throttle(callback, wait, thisArg) {
            var cancel = noop, last = !1;
            return function() {
                var time = now(), args = arguments, func = function() {
                    last = time, callback.apply(thisArg, args);
                };
                last && last + wait > time ? (cancel(), cancel = defer(func, wait)) : (last = time, 
                defer(func, 0));
            };
        }
        function viewport(referenceWindow) {
            var win = referenceWindow || window;
            return {
                height: win.innerHeight,
                width: win.innerWidth
            };
        }
        function computedStyle(element, referenceWindow) {
            return (referenceWindow || window).getComputedStyle(element, null);
        }
        function styleProperty(style, property) {
            return style.getPropertyValue(property);
        }
        function isDisplayed(element, style) {
            style || (style = computedStyle(element));
            var display = styleProperty(style, "display");
            if ("none" === display) return !1;
            var parent = element.parentNode;
            return isElement(parent) ? isDisplayed(parent) : !0;
        }
        function isVisibleByStyling(element, referenceWindow) {
            if (element === (referenceWindow || window).document) return !0;
            if (!element || !element.parentNode) return !1;
            var style = computedStyle(element, referenceWindow), visibility = styleProperty(style, "visibility");
            return "hidden" === visibility || "collapse" === visibility ? !1 : isDisplayed(element, style);
        }
        function isInViewport(rect, viewport) {
            return !rect || rect.width <= 0 || rect.height <= 0 ? !1 : rect.bottom > 0 && rect.right > 0 && rect.top < viewport.height && rect.left < viewport.width;
        }
        function percentage(element, referenceWindow) {
            var rect = element.getBoundingClientRect(), view = viewport(referenceWindow);
            if (!isInViewport(rect, view) || !isVisibleByStyling(element)) return 0;
            var vh = 0, vw = 0;
            return rect.top >= 0 ? vh = Math.min(rect.height, view.height - rect.top) : rect.bottom > 0 && (vh = Math.min(view.height, rect.bottom)), 
            rect.left >= 0 ? vw = Math.min(rect.width, view.width - rect.left) : rect.right > 0 && (vw = Math.min(view.width, rect.right)), 
            vh * vw / (rect.height * rect.width);
        }
        function isPageVisible(referenceWindow) {
            return !createVisibilityApi(referenceWindow || window).isHidden();
        }
        function VisSense(element, config) {
            if (!(this instanceof VisSense)) return new VisSense(element, config);
            if (!isElement(element)) throw new Error("not an element node");
            this._element = element, this._config = defaults(config, {
                fullyvisible: 1,
                hidden: 0,
                referenceWindow: window,
                percentageHook: percentage,
                precision: 3,
                visibilityHooks: []
            });
            var roundFactor = this._config.precision <= 0 ? 1 : Math.pow(10, this._config.precision || 3);
            this._round = function(val) {
                return Math.round(val * roundFactor) / roundFactor;
            };
            var visibilityApi = createVisibilityApi(this._config.referenceWindow);
            this._config.visibilityHooks.push(function() {
                return !visibilityApi.isHidden();
            });
        }
        function nextState(visobj, currentState) {
            var newState = visobj.state(), percentage = newState.percentage;
            return currentState && percentage === currentState.percentage && currentState.percentage === currentState.previous.percentage ? currentState : newState.hidden ? VisSense.VisState.hidden(percentage, currentState) : newState.fullyvisible ? VisSense.VisState.fullyvisible(percentage, currentState) : VisSense.VisState.visible(percentage, currentState);
        }
        function VisMon(visobj, config) {
            var _config = defaults(config, {
                strategy: [ new VisMon.Strategy.PollingStrategy(), new VisMon.Strategy.EventStrategy() ],
                async: !1
            });
            this._visobj = visobj, this._state = {}, this._started = !1;
            var anyTopicName = "*#" + now();
            this._pubsub = new PubSub({
                async: _config.async,
                anyTopicName: anyTopicName
            }), this._events = [ anyTopicName, "start", "stop", "update", "hidden", "visible", "fullyvisible", "percentagechange", "visibilitychange" ], 
            this._strategy = new VisMon.Strategy.CompositeStrategy(_config.strategy), this._strategy.init(this), 
            this._pubsub.on("update", function(monitor) {
                var newValue = monitor._state.percentage, oldValue = monitor._state.previous.percentage;
                newValue !== oldValue && monitor._pubsub.publish("percentagechange", [ monitor, newValue, oldValue ]);
            }), this._pubsub.on("update", function(monitor) {
                monitor._state.code !== monitor._state.previous.code && monitor._pubsub.publish("visibilitychange", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.visible && !monitor._state.previous.visible && monitor._pubsub.publish("visible", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.fullyvisible && monitor._pubsub.publish("fullyvisible", [ monitor ]);
            }), this._pubsub.on("visibilitychange", function(monitor) {
                monitor._state.hidden && monitor._pubsub.publish("hidden", [ monitor ]);
            }), forEach(this._events, function(event) {
                isFunction(_config[event]) && this.on(event, _config[event]);
            }, this);
        }
        var createVisibilityApi = function(referenceWindow) {
            return function(document, undefined$1) {
                var entry = function(propertyName, eventName) {
                    return {
                        property: propertyName,
                        event: eventName
                    };
                }, event = "visibilitychange", dict = [ entry("webkitHidden", "webkit" + event), entry("msHidden", "ms" + event), entry("mozHidden", "moz" + event), entry("hidden", event) ], api = forEach(dict, function(entry) {
                    return document[entry.property] !== undefined$1 ? {
                        isHidden: function() {
                            return !!document[entry.property] || !1;
                        },
                        onVisibilityChange: function(callback) {
                            return document.addEventListener(entry.event, callback, !1), function() {
                                document.removeEventListener(entry.event, callback, !1);
                            };
                        }
                    } : void 0;
                });
                return api || {
                    isHidden: function() {
                        return !1;
                    },
                    onVisibilityChange: function() {
                        return noop;
                    }
                };
            }((referenceWindow || window).document);
        }, PubSub = function(undefined$1) {
            function PubSub(config) {
                this._cache = {}, this._onAnyCache = [], this._config = defaults(config, {
                    async: !1,
                    anyTopicName: "*"
                });
            }
            var syncFireListeners = function(consumers, args) {
                forEach(consumers, function(consumer) {
                    consumer(args);
                });
            };
            return PubSub.prototype.on = function(topic, callback) {
                if (!isFunction(callback)) return noop;
                var applyCallback = function(args) {
                    return callback.apply(undefined$1, args || []);
                }, listener = this._config.async ? async(applyCallback) : applyCallback, unregister = function(listener, array, topic) {
                    return function() {
                        var index = array.indexOf(listener);
                        return index > -1 ? (array.splice(index, 1), !0) : !1;
                    };
                };
                return topic === this._config.anyTopicName ? (this._onAnyCache.push(listener), unregister(listener, this._onAnyCache)) : (this._cache[topic] || (this._cache[topic] = []), 
                this._cache[topic].push(listener), unregister(listener, this._cache[topic]));
            }, PubSub.prototype.publish = function(topic, args) {
                var listeners = (this._cache[topic] || []).concat(topic === this._config.anyTopicName ? [] : this._onAnyCache), enableAsync = !!this._config.async, syncOrAsyncPublish = enableAsync ? async(syncFireListeners) : function(listeners, args) {
                    return syncFireListeners(listeners, args), noop;
                };
                return syncOrAsyncPublish(listeners, args || []);
            }, PubSub;
        }();
        VisSense.prototype.state = function() {
            var hiddenByHook = forEach(this._config.visibilityHooks, function(hook) {
                return hook(this._element) ? void 0 : VisSense.VisState.hidden(0);
            }, this);
            return hiddenByHook || function(visobj, element, config) {
                var perc = visobj._round(config.percentageHook(element, config.referenceWindow));
                return perc <= config.hidden ? VisSense.VisState.hidden(perc) : perc >= config.fullyvisible ? VisSense.VisState.fullyvisible(perc) : VisSense.VisState.visible(perc);
            }(this, this._element, this._config);
        }, VisSense.prototype.percentage = function() {
            return this.state().percentage;
        }, VisSense.prototype.element = function() {
            return this._element;
        }, VisSense.prototype.referenceWindow = function() {
            return this._config.referenceWindow;
        }, VisSense.prototype.isFullyVisible = function() {
            return this.state().fullyvisible;
        }, VisSense.prototype.isVisible = function() {
            return this.state().visible;
        }, VisSense.prototype.isHidden = function() {
            return this.state().hidden;
        }, VisSense.fn = VisSense.prototype, VisSense.of = function(element, config) {
            return new VisSense(element, config);
        };
        var STATES = {
            HIDDEN: [ 0, "hidden" ],
            VISIBLE: [ 1, "visible" ],
            FULLY_VISIBLE: [ 2, "fullyvisible" ]
        };
        return VisSense.VisState = function() {
            function newVisState(state, percentage, previous) {
                return previous && delete previous.previous, {
                    code: state[0],
                    state: state[1],
                    percentage: percentage,
                    previous: previous || {},
                    fullyvisible: state[0] === STATES.FULLY_VISIBLE[0],
                    visible: state[0] === STATES.VISIBLE[0] || state[0] === STATES.FULLY_VISIBLE[0],
                    hidden: state[0] === STATES.HIDDEN[0]
                };
            }
            return {
                hidden: function(percentage, previous) {
                    return newVisState(STATES.HIDDEN, percentage, previous);
                },
                visible: function(percentage, previous) {
                    return newVisState(STATES.VISIBLE, percentage, previous);
                },
                fullyvisible: function(percentage, previous) {
                    return newVisState(STATES.FULLY_VISIBLE, percentage, previous);
                }
            };
        }(), VisMon.prototype.visobj = function() {
            return this._visobj;
        }, VisMon.prototype.publish = function(eventName, args) {
            var isInternalEvent = this._events.indexOf(eventName) >= 0;
            if (isInternalEvent) throw new Error('Cannot publish internal event "' + eventName + '" from external scope.');
            return this._pubsub.publish(eventName, args);
        }, VisMon.prototype.state = function() {
            return this._state;
        }, VisMon.prototype.start = function(config) {
            if (this._started) return this;
            var _config = defaults(config, {
                async: !1
            });
            return this._cancelAsyncStart && this._cancelAsyncStart(), _config.async ? this.startAsync() : (this._started = !0, 
            this.update(), this._pubsub.publish("start", [ this ]), this._strategy.start(this), 
            this);
        }, VisMon.prototype.startAsync = function(config) {
            this._cancelAsyncStart && this._cancelAsyncStart();
            var me = this, cancelAsyncStart = defer(function() {
                me.start(extend(defaults(config, {}), {
                    async: !1
                }));
            });
            return this._cancelAsyncStart = function() {
                cancelAsyncStart(), me._cancelAsyncStart = null;
            }, this;
        }, VisMon.prototype.stop = function() {
            this._cancelAsyncStart && this._cancelAsyncStart(), this._started && (this._strategy.stop(this), 
            this._pubsub.publish("stop", [ this ])), this._started = !1;
        }, VisMon.prototype.update = function() {
            this._started && (this._state = nextState(this._visobj, this._state), this._pubsub.publish("update", [ this ]));
        }, VisMon.prototype.on = function(topic, callback) {
            return this._pubsub.on(topic, callback);
        }, VisMon.Builder = function() {
            var combineStrategies = function(config, strategies) {
                var combinedStrategies = null, forceDisableStrategies = config.strategy === !1, enableStrategies = !forceDisableStrategies && (config.strategy || strategies.length > 0);
                if (enableStrategies) {
                    var configStrategyIsDefined = !!config.strategy, configStrategyIsArray = isArray(config.strategy), configStrategyAsArray = configStrategyIsDefined ? configStrategyIsArray ? config.strategy : [ config.strategy ] : [];
                    combinedStrategies = configStrategyAsArray.concat(strategies);
                } else combinedStrategies = forceDisableStrategies ? [] : config.strategy;
                return combinedStrategies;
            };
            return function(visobj) {
                var config = {}, strategies = [], events = [], productBuilt = !1, product = null;
                return {
                    set: function(name, value) {
                        return config[name] = value, this;
                    },
                    strategy: function(strategy) {
                        return strategies.push(strategy), this;
                    },
                    on: function(event, handler) {
                        return events.push([ event, handler ]), this;
                    },
                    build: function(consumer) {
                        var manufacture = function() {
                            var combinedStrategies = combineStrategies(config, strategies);
                            config.strategy = combinedStrategies;
                            var monitor = visobj.monitor(config);
                            return forEach(events, function(event) {
                                monitor.on(event[0], event[1]);
                            }), productBuilt = !0, product = monitor;
                        }, monitor = productBuilt ? product : manufacture();
                        return isFunction(consumer) ? consumer(monitor) : monitor;
                    }
                };
            };
        }(), VisMon.Strategy = function() {}, VisMon.Strategy.prototype.init = noop, VisMon.Strategy.prototype.start = noop, 
        VisMon.Strategy.prototype.stop = noop, VisMon.Strategy.CompositeStrategy = function(strategies) {
            this._strategies = isArray(strategies) ? strategies : [ strategies ];
        }, VisMon.Strategy.CompositeStrategy.prototype = Object.create(VisMon.Strategy.prototype), 
        VisMon.Strategy.CompositeStrategy.prototype.init = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.init) && strategy.init(monitor);
            });
        }, VisMon.Strategy.CompositeStrategy.prototype.start = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.start) && strategy.start(monitor);
            });
        }, VisMon.Strategy.CompositeStrategy.prototype.stop = function(monitor) {
            forEach(this._strategies, function(strategy) {
                isFunction(strategy.stop) && strategy.stop(monitor);
            });
        }, VisMon.Strategy.PollingStrategy = function(config) {
            this._config = defaults(config, {
                interval: 1e3
            }), this._started = !1;
        }, VisMon.Strategy.PollingStrategy.prototype = Object.create(VisMon.Strategy.prototype), 
        VisMon.Strategy.PollingStrategy.prototype.start = function(monitor) {
            return this._started || (this._clearInterval = function(interval) {
                var intervalId = setInterval(function() {
                    monitor.update();
                }, interval);
                return function() {
                    clearInterval(intervalId);
                };
            }(this._config.interval), this._started = !0), this._started;
        }, VisMon.Strategy.PollingStrategy.prototype.stop = function() {
            return this._started ? (this._clearInterval(), this._started = !1, !0) : !1;
        }, VisMon.Strategy.EventStrategy = function(config) {
            this._config = defaults(config, {
                throttle: 50
            }), this._config.debounce > 0 && (this._config.throttle = +this._config.debounce), 
            this._started = !1;
        }, VisMon.Strategy.EventStrategy.prototype = Object.create(VisMon.Strategy.prototype), 
        VisMon.Strategy.EventStrategy.prototype.start = function(monitor) {
            return this._started || (this._removeEventListeners = function(update) {
                var referenceWindow = monitor.visobj().referenceWindow(), visibilityApi = createVisibilityApi(referenceWindow), removeOnVisibilityChangeEvent = visibilityApi.onVisibilityChange(update);
                return referenceWindow.addEventListener("scroll", update, !1), referenceWindow.addEventListener("resize", update, !1), 
                referenceWindow.addEventListener("touchmove", update, !1), function() {
                    referenceWindow.removeEventListener("touchmove", update, !1), referenceWindow.removeEventListener("resize", update, !1), 
                    referenceWindow.removeEventListener("scroll", update, !1), removeOnVisibilityChangeEvent();
                };
            }(throttle(function() {
                monitor.update();
            }, this._config.throttle)), this._started = !0), this._started;
        }, VisMon.Strategy.EventStrategy.prototype.stop = function() {
            return this._started ? (this._removeEventListeners(), this._started = !1, !0) : !1;
        }, VisSense.VisMon = VisMon, VisSense.PubSub = PubSub, VisSense.fn.monitor = function(config) {
            return new VisMon(this, config);
        }, VisSense.Utils = {
            async: async,
            debounce: debounce,
            defaults: defaults,
            defer: defer,
            extend: extend,
            forEach: forEach,
            fireIf: fireIf,
            identity: identity,
            isArray: isArray,
            isDefined: isDefined,
            isElement: isElement,
            isFunction: isFunction,
            isObject: isObject,
            isPageVisible: isPageVisible,
            isVisibleByStyling: isVisibleByStyling,
            noop: noop,
            now: now,
            once: once,
            throttle: throttle,
            percentage: percentage,
            VisibilityApi: createVisibilityApi(),
            createVisibilityApi: createVisibilityApi,
            _viewport: viewport,
            _isInViewport: isInViewport,
            _isDisplayed: isDisplayed,
            _computedStyle: computedStyle,
            _styleProperty: styleProperty
        }, VisSense;
    });
    });

    var VisSense = vissense(window);
    var VisSenseUtils = VisSense.Utils;
    var createInnerMonitor = function (outerMonitor, callback, config) {
        var timeElapsed = 0;
        var timeStarted = null;
        var timeLimit = config.timeLimit;
        var percentageLimit = config.percentageLimit;
        var interval = config.interval;
        return VisSense.VisMon.Builder(outerMonitor.visobj())
            .strategy(new VisSense.VisMon.Strategy.PollingStrategy({ interval: interval }))
            .on('update', function (monitor) {
            var percentage = monitor.state().percentage;
            if (percentage < percentageLimit) {
                timeStarted = null;
            }
            else {
                var now = VisSenseUtils.now();
                timeStarted = timeStarted || now;
                timeElapsed = now - timeStarted;
            }
            if (timeElapsed >= timeLimit) {
                monitor.stop();
                outerMonitor.stop();
                callback(monitor);
            }
        })
            .on('stop', function () {
            timeStarted = null;
        })
            .build();
    };
    var onPercentageTimeTestPassed = function (visobj, callback, config) {
        var _config = VisSenseUtils.defaults(config, {
            percentageLimit: 1,
            timeLimit: 1000,
            interval: 100,
            strategy: undefined
        });
        // monitor is considered hidden if it is 1% below the percentage limit
        var hiddenLimit = Math.max(_config.percentageLimit - 0.001, 0);
        var innerMonitor = null;
        var outerMonitor = VisSense.VisMon.Builder(new VisSense(visobj.element(), {
            hidden: hiddenLimit,
            referenceWindow: visobj.referenceWindow()
        }))
            .set('strategy', _config.strategy)
            .on('visible', function (monitor) {
            if (innerMonitor === null) {
                innerMonitor = createInnerMonitor(monitor, callback, _config);
            }
            innerMonitor.start();
        })
            .on('hidden', function () {
            if (innerMonitor !== null) {
                innerMonitor.stop();
            }
        })
            .on('stop', function () {
            if (innerMonitor !== null) {
                innerMonitor.stop();
            }
        })
            .build();
        outerMonitor.start();
        return function () {
            outerMonitor.stop();
            innerMonitor = null;
        };
    };
    VisSense.fn.onPercentageTimeTestPassed = function (callback, config) {
        onPercentageTimeTestPassed(this, callback, config);
    };

    /**
     *埋点入口类
     *
     * @class ActionTracker
     */
    var ActionTracker = /** @class */ (function () {
        function ActionTracker() {
            this.record = {
                pageId: '',
                pageTrackTime: null,
                eventId: '',
                eventTrackTime: null
            };
            this.trackEvent = this.trackEvent.bind(this);
            this.trackPage = this.trackPage.bind(this);
            this.trackViewStart = this.trackViewStart.bind(this);
            this.trackView = this.trackView.bind(this);
            this.trackViewEnd = this.trackViewEnd.bind(this);
            this.trackLog = this.trackLog.bind(this);
        }
        ActionTracker.getInstance = function () {
            if (!ActionTracker.instance) {
                ActionTracker.instance = new ActionTracker();
            }
            return ActionTracker.instance;
        };
        /**
         * 埋点页面,
         * @memberof ActionTracker
         */
        ActionTracker.prototype.trackPage = function (info) {
            var _this = this;
            if (info === void 0) { info = {}; }
            setTimeout(function () {
                var _a = getConfig(), offlineUrl = _a.offlineUrl, autoTrackPrefix = _a.autoTrackPrefix;
                var data = __assign({ actionType: ACTION_TYPE.PAGE }, info);
                if (!data.trackId) {
                    data.trackId = autoTrackPrefix + "page-" + hashCode(getRealPath(window.location.href, offlineUrl));
                    data.isAutoTrack = true; // 无痕埋点标记
                    _this.record.pageId = null;
                }
                else {
                    // 同样记录无痕url
                    _this.record.pageTrackTime = Date.now();
                    _this.record.pageId = data.trackId;
                    data.autoTrackId = autoTrackPrefix + "page-" + hashCode(getRealPath(window.location.href, offlineUrl));
                }
                data.pageId = data.trackId;
                send(data);
            }, 0);
        };
        /**
         *
         * 事件埋点
         */
        ActionTracker.prototype.trackEvent = function (info) {
            if (info === void 0) { info = {}; }
            this._trackEvent(info);
        };
        /**
         *
         * 事件埋点传dom
         *
         */
        ActionTracker.prototype._trackEvent = function (info, domInfo) {
            if (info === void 0) { info = {}; }
            var _a = getConfig(), offlineUrl = _a.offlineUrl, autoTrackPrefix = _a.autoTrackPrefix;
            var data = __assign({ actionType: ACTION_TYPE.EVENT, eventName: 'CLICK' }, info);
            if (!data.trackId && !data.debug && domInfo) {
                var code = domInfo.domId ? hashCode(domInfo.domId) : hashCode(domInfo.domPath + domInfo.domTag);
                data.trackId = autoTrackPrefix + "event-" + hashCode(getRealPath(window.location.href, offlineUrl)) + "-" + code;
                data.isAutoTrack = true;
            }
            send(data);
        };
        /**
         * 视窗埋点 暂时不启用
         * @param dom
         * @param info
         * @param visSenseConfig
         */
        ActionTracker.prototype.trackView = function (dom, info, visSenseConfig) {
            if (visSenseConfig === void 0) { visSenseConfig = {}; }
            if (dom) {
                var data_1 = __assign({ actionType: ACTION_TYPE.VIEW, domId: dom.id, domClass: dom.className, domTag: dom.tagName, domContent: dom.textContent.substr(0, 20).trim(), domPath: getDomPath(dom) }, info);
                var visobj = VisSense(dom);
                visobj.onPercentageTimeTestPassed(function () {
                    send(data_1);
                }, {
                    percentageLimit: visSenseConfig.percentageLimit || 1,
                    timeLimit: visSenseConfig.timeLimit || 0,
                    interval: 200
                });
            }
        };
        ActionTracker.prototype.trackViewStart = function (info) {
            send(__assign(__assign({}, info), { actionType: ACTION_TYPE.VIEW }));
        };
        ActionTracker.prototype.trackViewEnd = function (info) {
            var logs = instance.end(info);
            sendQuick(logs);
        };
        /**
         *通用埋点入口 根据埋点类型调用
         *
         */
        ActionTracker.prototype.track = function (info) {
            switch (info.actionType) {
                case ACTION_TYPE.EVENT:
                    this.trackEvent(info);
                    break;
                case ACTION_TYPE.PAGE:
                    this.trackPage(info);
                    break;
                default:
                    break;
            }
            send(info);
        };
        /**
         * a标签埋点 做300毫秒延迟跳转 确保埋点成功 (暂时注销)
         * @param linkDom
         * @param info
         */
        ActionTracker.prototype.trackLink = function (linkDom, info) {
            if (info === void 0) { info = {}; }
            var config = getConfig();
            var url = linkDom.getAttribute('href');
            if (config.delayLink && url && /\//.test(url)) {
                setTimeout(function () {
                    if (linkDom.getAttribute('target') === '_blank') {
                        window.open(url);
                    }
                    else {
                        window.location.href = url;
                    }
                }, config.delayLinkTime);
            }
            this.trackDom(linkDom, info);
            sendAsync();
        };
        /**
         *埋点dom 做1秒防抖
         *
         * @param {(HTMLLinkElement | HTMLInputElement | HTMLLinkElement)} dom
         * @param {ITrackerData} [info={}]
         * @returns
         * @memberof ActionTracker
         */
        ActionTracker.prototype.trackDom = function (dom, info) {
            if (info === void 0) { info = {}; }
            //防止频繁触发
            var _dom = dom;
            if (_dom.IS_TRACKED) {
                clearTimeout(_dom.DELAY_TRACK_TIME);
                _dom.DELAY_TRACK_TIME = setTimeout(function () {
                    _dom.IS_TRACKED = false;
                }, 1000);
                return;
            }
            _dom.IS_TRACKED = true;
            _dom.DELAY_TRACK_TIME = setTimeout(function () {
                _dom.IS_TRACKED = false;
            }, 1000);
            var domPath = getDomPath(dom);
            var trackInfo = {
                trackId: '',
                domPath: domPath,
                domContent: dom.textContent.substr(0, 20).trim(),
                domHref: dom.href || dom.src || null
            };
            var domInfo = {
                domId: dom.id,
                domClass: dom.className,
                domHref: dom.href || dom.src || '',
                domName: dom.name || '',
                domTag: dom.tagName,
                domPath: domPath,
                domContent: dom.textContent.substr(0, 20).trim()
            };
            var track = dom.getAttribute('data-track');
            if (track && track.search(/^\{[\S\s]*\}$/) >= 0) {
                trackInfo = __assign(__assign({}, trackInfo), JSON.parse(track));
            }
            else {
                trackInfo.trackId = track || '';
            }
            if (info) {
                trackInfo = __assign(__assign({}, trackInfo), info);
            }
            this._trackEvent(trackInfo, domInfo);
        };
        /**
         * 前端日志收集
         * @memberof ActionTracker
         */
        ActionTracker.prototype.trackLog = function (info) {
            if (info === void 0) { info = {}; }
            var data = __assign({ actionType: ACTION_TYPE.EVENT, eventName: 'CLICK', debug: true }, info);
            send(data);
        };
        ActionTracker.instance = null;
        return ActionTracker;
    }());
    var instance$1 = ActionTracker.getInstance();

    function hijackHistoryEvent () {
        if (getFlag('historyInjected'))
            return;
        function historyEventTrigger(event, data) {
            var fetchEvent = new CustomEvent(event, { detail: data });
            window.dispatchEvent(fetchEvent);
        }
        function spellUrl(oldURL, newURL) {
            if (/:\/\//.test(newURL)) {
                return newURL;
            }
            var host = oldURL.match(/^.*:\/\/[^/]+/)[0];
            return host + (/^\//.test(newURL) ? '' : '/') + newURL;
        }
        var globalData = {
            url: getLocationHref()
        };
        var oldOnpopstate = window.onpopstate;
        window.onpopstate = function () {
            var data = {
                newURL: window.location.href,
                oldURL: globalData.url
            };
            globalData.url = window.location.href;
            historyEventTrigger.apply(this, ['historyPopstate', data]);
            if (oldOnpopstate) {
                return oldOnpopstate.apply(this, arguments);
            }
        };
        var oldPushState = window.history.pushState;
        oldPushState &&
            (window.history.pushState = function (state, title, url) {
                var data = {
                    newURL: spellUrl(globalData.url, url),
                    oldURL: globalData.url
                };
                globalData = {
                    url: data.newURL
                };
                historyEventTrigger.apply(this, ['historyPushState', data]);
                if (oldPushState) {
                    return oldPushState.apply(this, arguments);
                }
            });
        setFlag('historyInjected', true);
    }

    function injectedXHR () {
        if (getFlag('XHRInjected'))
            return;
        var oldOpen = XMLHttpRequest.prototype.open;
        var oldSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function () {
            this.url = arguments[1];
            oldOpen.apply(this, arguments);
        };
        XMLHttpRequest.prototype.send = function () {
            var logId = window._TELESCOPE_LOG_ID;
            if (/^https?:\/\/[^.]*\.?apigw\.qa\.(91jkys|dia-solution)\.com/.test(this.url) && logId) {
                this.setRequestHeader('Frontend-Log-Id', logId);
            }
            oldSend.apply(this, arguments);
        };
        XMLHttpRequest.prototype.oldOpen = oldOpen;
        XMLHttpRequest.prototype.oldSend = oldSend;
        setFlag('XHRInjected', true);
    }

    // 立即执行 防止页面重定向
    setClientInfo({});
    var install = function (conf) {
        if (getFlag('install'))
            return;
        setFlag('install');
        if (conf) {
            setConfig(conf);
        }
        var config = getConfig();
        if (!config.version && window.version && typeof window.version === 'string') {
            setConfig({ version: window.version });
        }
        setClientInfo({});
        //劫持xhr
        injectedXHR();
        //注入history事件
        hijackHistoryEvent();
        //自动埋页面;
        routeChange();
        var timer = null;
        var timer2 = null;
        function routeChange() {
            login(); //每次路由编号就获取用户信息 兼容中途登录
            var config = getConfig();
            clearTimeout(timer);
            clearTimeout(timer2);
            if (config.autoTrackPage) {
                // 延迟500ms, 如果最近1s内发送过页面曝光则不进行自动埋点
                timer = setTimeout(function () {
                    var pageInfo = getPageInfo();
                    if (!pageInfo.pageId && Date.now() - instance$1.record.pageTrackTime > 1000) {
                        instance$1.trackPage();
                    }
                }, 500);
            }
            timer2 = setTimeout(function () {
                if (Date.now() - instance$1.record.pageTrackTime > 1000) {
                    setPageInfo({ pageId: '' });
                }
            }, 100);
            if (config.routeChangeAfter) {
                config.routeChangeAfter();
            }
            setReferrerId('UPDATE');
            setSourceEventId('UPDATE');
            sendInfo();
        }
        // 单页面应用routerchange
        if (typeof window.onpopstate === 'undefined') {
            window.addEventListener('hashchange', routeChange);
        }
        window.addEventListener('historyPushState', routeChange);
        window.addEventListener('historyPopstate', routeChange);
        window.addEventListener('visibilitychange', function () {
            var isHidden = document.hidden;
            var pageInfo = getPageInfo();
            if (isHidden) {
                var logs = instance.end();
                sendQuick(logs);
            }
            else {
                instance$1.trackPage({ trackId: pageInfo.pageId });
            }
        });
        // onbeforeunload 和 onunload 都触发发送
        var onLeave = (function () {
            var sended = false;
            return function () {
                if (sended) {
                    return;
                }
                var logs = instance.end();
                sendQuick(logs);
                sended = true;
            };
        })();
        var beatFn = function () {
            setReferrerId('BEAT');
            var config = getConfig();
            if (config.sendBeat) {
                var logs = instance.beat();
                sendBeat(logs); //todo
            }
            setTimeout(beatFn, 3000);
        };
        setTimeout(beatFn, 3000);
        // const beatUpload = () => {
        //   const logs = durationTime.beat();
        //   sendQuick(logs);
        //   setTimeout(beatUpload, 3000);
        // };
        // setTimeout(beatUpload, 3000);
        window.addEventListener('beforeunload', onLeave);
        window.addEventListener('unload', onLeave);
        document.addEventListener('click', function (e) {
            var element = e.target;
            var config = getConfig();
            var pageId = getPageInfo().pageId;
            var hasTrack = false;
            while (element && element.tagName && element.tagName.toUpperCase() !== 'HTML' && element.getAttribute) {
                var href = element.getAttribute('href');
                // 阻止a标签跳转
                if (href && element.tagName === 'A' && /\//.test(href) && config.delayLink) {
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    else {
                        window.event.returnValue = true;
                    }
                }
                //是否有埋点属性或者交互标签
                if (element.getAttribute('data-track') ||
                    (config.autoTrackClick &&
                        (element.tagName === 'A' ||
                            element.tagName === 'BUTTON' ||
                            element.tagName === 'INPUT' ||
                            element.getAttribute('role')) &&
                        !element._isWatchTrack)) {
                    if (element.tagName === 'A') {
                        if (!/referrer\-id=/.test(element.href) && pageId && typeof pageId === 'string' && /\//.test(href)) {
                            if (/\?.*=/.test(element.href)) {
                                element.href = element.href.replace(/\?/, "?referrer-id=" + pageId + "&");
                            }
                            else if (/\?/.test(element.href) === false) {
                                element.href += "?referrer-id=" + pageId;
                            }
                        }
                        if (config.delayLink && /\//.test(href)) {
                            instance$1.trackLink(element);
                        }
                        else {
                            instance$1.trackDom(element);
                        }
                    }
                    else {
                        instance$1.trackDom(element);
                    }
                    hasTrack = true;
                }
                else if (element._isWatchTrack) {
                    hasTrack = true;
                }
                element = element.parentNode;
            }
            //如果没有触发任何无痕/有痕埋点 则把当前点击dom进行无痕
            if (!hasTrack && e.target && config.autoTrackClick) {
                instance$1.trackDom(e.target);
            }
        }, false);
    };
    //自动install
    window.addEventListener('DOMContentLoaded', function () {
        var config = getConfig();
        if (config.autoInstall) {
            install();
        }
    });

    try {
        var ua_1 = window.navigator.userAgent;
        var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
        var host = window.location.host;
        //跟进host 判断环境
        if (/(pre|qa|127|192)\.|localhost/.test(host) || (/env\((pre|qa)\)/i.test(ua_1) && !host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.qa.91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.qa.91jkys.com/duration.gif"
            });
        }
        else if (/zyhealth\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.zyhealth.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.zyhealth.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.zyhealth.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.zyhealth.com/duration.gif"
            });
        }
        else if (/dia-solution\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.dia-solution.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.dia-solution.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.dia-solution.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.dia-solution.com/duration.gif"
            });
        }
        else if (/c4-91jkys\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.c4-91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.c4-91jkys.com/duration.gif"
            });
        }
        else if (/c10-91jkys\.com/.test(host)) {
            setConfig({
                serverUrl: protocol + "//frontlo-collection.c10-91jkys.com/log_h5.gif",
                debugServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/f2e/log.gif",
                beatServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/beat.gif",
                durationServerUrl: protocol + "//frontlo-collection.c10-91jkys.com/duration.gif"
            });
        }
        //获取客户端deviceId
        if (/DeviceId/i.test(ua_1)) {
            var deviceIdMatch = ua_1.match(/DeviceId\((.*?)\)/);
            if (deviceIdMatch && deviceIdMatch.length >= 2) {
                setClientInfo({
                    deviceId: deviceIdMatch[1]
                });
            }
        }
        //获取appID 和app版本
        if (/AppInfo/i.test(ua_1)) {
            var AppInfoMatch = ua_1.match(/AppInfo\((.*?);(.*?)\)/);
            if (AppInfoMatch && AppInfoMatch.length >= 3) {
                setClientInfo({
                    appId: AppInfoMatch[1],
                    appVersion: AppInfoMatch[2],
                    appType: 'APP'
                });
            }
        }
        if (/AppInfo|tangyi/.test(ua_1)) {
            setConfig({
                autoInstall: false
            });
            var isReady_1 = false; // 处理sailerready 执行两次问题
            var appInit_1 = function () {
                Sailer.ready(function () {
                    if (isReady_1) {
                        return;
                    }
                    isReady_1 = true;
                    // 获取userId
                    var uid = Sailer.getUserInfo().uid;
                    if (uid > 0) {
                        login({ uid: uid });
                    }
                    if (!Sailer.getEventInfo || !/zhiyun_patient/.test(ua_1)) {
                        install();
                        return;
                    }
                    Sailer.nativeCall('getEventInfo', function (res) {
                        if (!res || !res.data) {
                            return;
                        }
                        var eventInfo = res.data;
                        if (eventInfo && eventInfo.items && eventInfo.items.length) {
                            setClientInfo({
                                channel: eventInfo.items[0].channel,
                                deviceId: eventInfo.deviceId,
                                appId: eventInfo.appId,
                                appVersion: eventInfo.version,
                                sessionId: eventInfo.items[0].sessionId
                            });
                            setPageInfo({
                                referrerId: eventInfo.items[0].pageId,
                                sourceEventId: eventInfo.items[0].trackId
                            });
                        }
                        install();
                    });
                });
            };
            if (typeof Sailer !== 'undefined') {
                appInit_1();
            }
            else {
                //兼容sdk引入顺序错误
                setTimeout(function () {
                    if (typeof Sailer !== 'undefined') {
                        appInit_1();
                    }
                    else {
                        login();
                        install();
                    }
                }, 0);
            }
        }
        else {
            login();
        }
    }
    catch (error) {
        console.error(error);
    }

    /**
     * Optimized internal three-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */


    function _curry3(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;

          case 1:
            return _isPlaceholder_1(a) ? f3 : _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            });

          case 2:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) ? f3 : _isPlaceholder_1(a) ? _curry2_1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder_1(b) ? _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1_1(function (_c) {
              return fn(a, b, _c);
            });

          default:
            return _isPlaceholder_1(a) && _isPlaceholder_1(b) && _isPlaceholder_1(c) ? f3 : _isPlaceholder_1(a) && _isPlaceholder_1(b) ? _curry2_1(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder_1(a) && _isPlaceholder_1(c) ? _curry2_1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder_1(b) && _isPlaceholder_1(c) ? _curry2_1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder_1(a) ? _curry1_1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder_1(b) ? _curry1_1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder_1(c) ? _curry1_1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }

    var _curry3_1 = _curry3;

    /**
     * Returns a function that always returns the given value. Note that for
     * non-primitives the value returned is a reference to the original value.
     *
     * This function is known as `const`, `constant`, or `K` (for K combinator) in
     * other languages and libraries.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Function
     * @sig a -> (* -> a)
     * @param {*} val The value to wrap in a function
     * @return {Function} A Function :: * -> val.
     * @example
     *
     *      const t = R.always('Tee');
     *      t(); //=> 'Tee'
     */


    var always =
    /*#__PURE__*/
    _curry1_1(function always(val) {
      return function () {
        return val;
      };
    });

    var always_1 = always;

    // `Identity` is a functor that holds a single value, where `map` simply
    // transforms the held value with the provided function.


    var Identity = function (x) {
      return {
        value: x,
        map: function (f) {
          return Identity(f(x));
        }
      };
    };
    /**
     * Returns the result of "setting" the portion of the given data structure
     * focused by the given lens to the result of applying the given function to
     * the focused value.
     *
     * @func
     * @memberOf R
     * @since v0.16.0
     * @category Object
     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
     * @sig Lens s a -> (a -> a) -> s -> s
     * @param {Lens} lens
     * @param {*} v
     * @param {*} x
     * @return {*}
     * @see R.prop, R.lensIndex, R.lensProp
     * @example
     *
     *      const headLens = R.lensIndex(0);
     *
     *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
     */


    var over =
    /*#__PURE__*/
    _curry3_1(function over(lens, f, x) {
      // The value returned by the getter function is first transformed with `f`,
      // then set as the value of an `Identity`. This is then mapped over with the
      // setter function of the lens.
      return lens(function (y) {
        return Identity(f(y));
      })(x).value;
    });

    var over_1 = over;

    /**
     * Returns the result of "setting" the portion of the given data structure
     * focused by the given lens to the given value.
     *
     * @func
     * @memberOf R
     * @since v0.16.0
     * @category Object
     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
     * @sig Lens s a -> a -> s -> s
     * @param {Lens} lens
     * @param {*} v
     * @param {*} x
     * @return {*}
     * @see R.prop, R.lensIndex, R.lensProp
     * @example
     *
     *      const xLens = R.lensProp('x');
     *
     *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
     *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
     */


    var set =
    /*#__PURE__*/
    _curry3_1(function set(lens, v, x) {
      return over_1(lens, always_1(v), x);
    });

    var set_1 = set;

    function _isPlaceholder$1(a) {
      return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }

    /**
     * Optimized internal one-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry1$1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder$1(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }

    /**
     * Optimized internal two-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry2$1(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;

          case 1:
            return _isPlaceholder$1(a) ? f2 : _curry1$1(function (_b) {
              return fn(a, _b);
            });

          default:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f2 : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }

    function _arity(n, fn) {
      /* eslint-disable no-unused-vars */
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };

        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };

        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };

        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };

        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };

        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };

        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };

        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };

        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };

        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };

        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };

        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }

    /**
     * Internal curryN function.
     *
     * @private
     * @category Function
     * @param {Number} length The arity of the curried function.
     * @param {Array} received An array of arguments received thus far.
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curryN(length, received, fn) {
      return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;

        while (combinedIdx < received.length || argsIdx < arguments.length) {
          var result;

          if (combinedIdx < received.length && (!_isPlaceholder$1(received[combinedIdx]) || argsIdx >= arguments.length)) {
            result = received[combinedIdx];
          } else {
            result = arguments[argsIdx];
            argsIdx += 1;
          }

          combined[combinedIdx] = result;

          if (!_isPlaceholder$1(result)) {
            left -= 1;
          }

          combinedIdx += 1;
        }

        return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
      };
    }

    /**
     * Returns a curried equivalent of the provided function, with the specified
     * arity. The curried function has two unusual capabilities. First, its
     * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
     * following are equivalent:
     *
     *   - `g(1)(2)(3)`
     *   - `g(1)(2, 3)`
     *   - `g(1, 2)(3)`
     *   - `g(1, 2, 3)`
     *
     * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
     * "gaps", allowing partial application of any combination of arguments,
     * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
     * the following are equivalent:
     *
     *   - `g(1, 2, 3)`
     *   - `g(_, 2, 3)(1)`
     *   - `g(_, _, 3)(1)(2)`
     *   - `g(_, _, 3)(1, 2)`
     *   - `g(_, 2)(1)(3)`
     *   - `g(_, 2)(1, 3)`
     *   - `g(_, 2)(_, 3)(1)`
     *
     * @func
     * @memberOf R
     * @since v0.5.0
     * @category Function
     * @sig Number -> (* -> a) -> (* -> a)
     * @param {Number} length The arity for the returned function.
     * @param {Function} fn The function to curry.
     * @return {Function} A new, curried function.
     * @see R.curry
     * @example
     *
     *      const sumArgs = (...args) => R.sum(args);
     *
     *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
     *      const f = curriedAddFourNumbers(1, 2);
     *      const g = f(3);
     *      g(4); //=> 10
     */

    var curryN =
    /*#__PURE__*/
    _curry2$1(function curryN(length, fn) {
      if (length === 1) {
        return _curry1$1(fn);
      }

      return _arity(length, _curryN(length, [], fn));
    });

    /**
     * Optimized internal three-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry3$1(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;

          case 1:
            return _isPlaceholder$1(a) ? f3 : _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            });

          case 2:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f3 : _isPlaceholder$1(a) ? _curry2$1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder$1(b) ? _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1$1(function (_c) {
              return fn(a, b, _c);
            });

          default:
            return _isPlaceholder$1(a) && _isPlaceholder$1(b) && _isPlaceholder$1(c) ? f3 : _isPlaceholder$1(a) && _isPlaceholder$1(b) ? _curry2$1(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder$1(a) && _isPlaceholder$1(c) ? _curry2$1(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder$1(b) && _isPlaceholder$1(c) ? _curry2$1(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder$1(c) ? _curry1$1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }

    /**
     * Tests whether or not an object is an array.
     *
     * @private
     * @param {*} val The object to test.
     * @return {Boolean} `true` if `val` is an array, `false` otherwise.
     * @example
     *
     *      _isArray([]); //=> true
     *      _isArray(null); //=> false
     *      _isArray({}); //=> false
     */
    var _isArray = Array.isArray || function _isArray(val) {
      return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
    };

    function _isTransformer(obj) {
      return obj != null && typeof obj['@@transducer/step'] === 'function';
    }

    /**
     * Returns a function that dispatches with different strategies based on the
     * object in list position (last argument). If it is an array, executes [fn].
     * Otherwise, if it has a function with one of the given method names, it will
     * execute that function (functor case). Otherwise, if it is a transformer,
     * uses transducer [xf] to return a new transformer (transducer case).
     * Otherwise, it will default to executing [fn].
     *
     * @private
     * @param {Array} methodNames properties to check for a custom implementation
     * @param {Function} xf transducer to initialize if object is transformer
     * @param {Function} fn default ramda implementation
     * @return {Function} A function that dispatches on object in list position
     */

    function _dispatchable(methodNames, xf, fn) {
      return function () {
        if (arguments.length === 0) {
          return fn();
        }

        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();

        if (!_isArray(obj)) {
          var idx = 0;

          while (idx < methodNames.length) {
            if (typeof obj[methodNames[idx]] === 'function') {
              return obj[methodNames[idx]].apply(obj, args);
            }

            idx += 1;
          }

          if (_isTransformer(obj)) {
            var transducer = xf.apply(null, args);
            return transducer(obj);
          }
        }

        return fn.apply(this, arguments);
      };
    }

    var _xfBase = {
      init: function () {
        return this.xf['@@transducer/init']();
      },
      result: function (result) {
        return this.xf['@@transducer/result'](result);
      }
    };

    function _map(fn, functor) {
      var idx = 0;
      var len = functor.length;
      var result = Array(len);

      while (idx < len) {
        result[idx] = fn(functor[idx]);
        idx += 1;
      }

      return result;
    }

    function _isString(x) {
      return Object.prototype.toString.call(x) === '[object String]';
    }

    /**
     * Tests whether or not an object is similar to an array.
     *
     * @private
     * @category Type
     * @category List
     * @sig * -> Boolean
     * @param {*} x The object to test.
     * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
     * @example
     *
     *      _isArrayLike([]); //=> true
     *      _isArrayLike(true); //=> false
     *      _isArrayLike({}); //=> false
     *      _isArrayLike({length: 10}); //=> false
     *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
     */

    var _isArrayLike =
    /*#__PURE__*/
    _curry1$1(function isArrayLike(x) {
      if (_isArray(x)) {
        return true;
      }

      if (!x) {
        return false;
      }

      if (typeof x !== 'object') {
        return false;
      }

      if (_isString(x)) {
        return false;
      }

      if (x.nodeType === 1) {
        return !!x.length;
      }

      if (x.length === 0) {
        return true;
      }

      if (x.length > 0) {
        return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
      }

      return false;
    });

    var XWrap =
    /*#__PURE__*/
    function () {
      function XWrap(fn) {
        this.f = fn;
      }

      XWrap.prototype['@@transducer/init'] = function () {
        throw new Error('init not implemented on XWrap');
      };

      XWrap.prototype['@@transducer/result'] = function (acc) {
        return acc;
      };

      XWrap.prototype['@@transducer/step'] = function (acc, x) {
        return this.f(acc, x);
      };

      return XWrap;
    }();

    function _xwrap(fn) {
      return new XWrap(fn);
    }

    /**
     * Creates a function that is bound to a context.
     * Note: `R.bind` does not provide the additional argument-binding capabilities of
     * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
     *
     * @func
     * @memberOf R
     * @since v0.6.0
     * @category Function
     * @category Object
     * @sig (* -> *) -> {*} -> (* -> *)
     * @param {Function} fn The function to bind to context
     * @param {Object} thisObj The context to bind `fn` to
     * @return {Function} A function that will execute in the context of `thisObj`.
     * @see R.partial
     * @example
     *
     *      const log = R.bind(console.log, console);
     *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
     *      // logs {a: 2}
     * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
     */

    var bind =
    /*#__PURE__*/
    _curry2$1(function bind(fn, thisObj) {
      return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
      });
    });

    function _arrayReduce(xf, acc, list) {
      var idx = 0;
      var len = list.length;

      while (idx < len) {
        acc = xf['@@transducer/step'](acc, list[idx]);

        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }

        idx += 1;
      }

      return xf['@@transducer/result'](acc);
    }

    function _iterableReduce(xf, acc, iter) {
      var step = iter.next();

      while (!step.done) {
        acc = xf['@@transducer/step'](acc, step.value);

        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }

        step = iter.next();
      }

      return xf['@@transducer/result'](acc);
    }

    function _methodReduce(xf, acc, obj, methodName) {
      return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
    }

    var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
    function _reduce(fn, acc, list) {
      if (typeof fn === 'function') {
        fn = _xwrap(fn);
      }

      if (_isArrayLike(list)) {
        return _arrayReduce(fn, acc, list);
      }

      if (typeof list['fantasy-land/reduce'] === 'function') {
        return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
      }

      if (list[symIterator] != null) {
        return _iterableReduce(fn, acc, list[symIterator]());
      }

      if (typeof list.next === 'function') {
        return _iterableReduce(fn, acc, list);
      }

      if (typeof list.reduce === 'function') {
        return _methodReduce(fn, acc, list, 'reduce');
      }

      throw new TypeError('reduce: list must be array or iterable');
    }

    var XMap =
    /*#__PURE__*/
    function () {
      function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
      }

      XMap.prototype['@@transducer/init'] = _xfBase.init;
      XMap.prototype['@@transducer/result'] = _xfBase.result;

      XMap.prototype['@@transducer/step'] = function (result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
      };

      return XMap;
    }();

    var _xmap =
    /*#__PURE__*/
    _curry2$1(function _xmap(f, xf) {
      return new XMap(f, xf);
    });

    function _has$1(prop, obj) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }

    var toString$1 = Object.prototype.toString;

    var _isArguments$1 =
    /*#__PURE__*/
    function () {
      return toString$1.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString$1.call(x) === '[object Arguments]';
      } : function _isArguments(x) {
        return _has$1('callee', x);
      };
    }();

    var hasEnumBug$1 = !
    /*#__PURE__*/
    {
      toString: null
    }.propertyIsEnumerable('toString');
    var nonEnumerableProps$1 = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

    var hasArgsEnumBug$1 =
    /*#__PURE__*/
    function () {

      return arguments.propertyIsEnumerable('length');
    }();

    var contains$1 = function contains(list, item) {
      var idx = 0;

      while (idx < list.length) {
        if (list[idx] === item) {
          return true;
        }

        idx += 1;
      }

      return false;
    };
    /**
     * Returns a list containing the names of all the enumerable own properties of
     * the supplied object.
     * Note that the order of the output array is not guaranteed to be consistent
     * across different JS platforms.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Object
     * @sig {k: v} -> [k]
     * @param {Object} obj The object to extract properties from
     * @return {Array} An array of the object's own properties.
     * @see R.keysIn, R.values
     * @example
     *
     *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
     */


    var keys$1 = typeof Object.keys === 'function' && !hasArgsEnumBug$1 ?
    /*#__PURE__*/
    _curry1$1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    /*#__PURE__*/
    _curry1$1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }

      var prop, nIdx;
      var ks = [];

      var checkArgsLength = hasArgsEnumBug$1 && _isArguments$1(obj);

      for (prop in obj) {
        if (_has$1(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }

      if (hasEnumBug$1) {
        nIdx = nonEnumerableProps$1.length - 1;

        while (nIdx >= 0) {
          prop = nonEnumerableProps$1[nIdx];

          if (_has$1(prop, obj) && !contains$1(ks, prop)) {
            ks[ks.length] = prop;
          }

          nIdx -= 1;
        }
      }

      return ks;
    });

    /**
     * Takes a function and
     * a [functor](https://github.com/fantasyland/fantasy-land#functor),
     * applies the function to each of the functor's values, and returns
     * a functor of the same shape.
     *
     * Ramda provides suitable `map` implementations for `Array` and `Object`,
     * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
     *
     * Dispatches to the `map` method of the second argument, if present.
     *
     * Acts as a transducer if a transformer is given in list position.
     *
     * Also treats functions as functors and will compose them together.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig Functor f => (a -> b) -> f a -> f b
     * @param {Function} fn The function to be called on every element of the input `list`.
     * @param {Array} list The list to be iterated over.
     * @return {Array} The new list.
     * @see R.transduce, R.addIndex
     * @example
     *
     *      const double = x => x * 2;
     *
     *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
     *
     *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
     * @symb R.map(f, [a, b]) = [f(a), f(b)]
     * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
     * @symb R.map(f, functor_o) = functor_o.map(f)
     */

    var map =
    /*#__PURE__*/
    _curry2$1(
    /*#__PURE__*/
    _dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
      switch (Object.prototype.toString.call(functor)) {
        case '[object Function]':
          return curryN(functor.length, function () {
            return fn.call(this, functor.apply(this, arguments));
          });

        case '[object Object]':
          return _reduce(function (acc, key) {
            acc[key] = fn(functor[key]);
            return acc;
          }, {}, keys$1(functor));

        default:
          return _map(fn, functor);
      }
    }));

    /**
     * Determine if the passed argument is an integer.
     *
     * @private
     * @param {*} n
     * @category Type
     * @return {Boolean}
     */
    var _isInteger = Number.isInteger || function _isInteger(n) {
      return n << 0 === n;
    };

    /**
     * Returns the nth element of the given list or string. If n is negative the
     * element at index length + n is returned.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig Number -> [a] -> a | Undefined
     * @sig Number -> String -> String
     * @param {Number} offset
     * @param {*} list
     * @return {*}
     * @example
     *
     *      const list = ['foo', 'bar', 'baz', 'quux'];
     *      R.nth(1, list); //=> 'bar'
     *      R.nth(-1, list); //=> 'quux'
     *      R.nth(-99, list); //=> undefined
     *
     *      R.nth(2, 'abc'); //=> 'c'
     *      R.nth(3, 'abc'); //=> ''
     * @symb R.nth(-1, [a, b, c]) = c
     * @symb R.nth(0, [a, b, c]) = a
     * @symb R.nth(1, [a, b, c]) = b
     */

    var nth =
    /*#__PURE__*/
    _curry2$1(function nth(offset, list) {
      var idx = offset < 0 ? list.length + offset : offset;
      return _isString(list) ? list.charAt(idx) : list[idx];
    });

    /**
     * Retrieves the values at given paths of an object.
     *
     * @func
     * @memberOf R
     * @since v0.27.0
     * @category Object
     * @typedefn Idx = [String | Int]
     * @sig [Idx] -> {a} -> [a | Undefined]
     * @param {Array} pathsArray The array of paths to be fetched.
     * @param {Object} obj The object to retrieve the nested properties from.
     * @return {Array} A list consisting of values at paths specified by "pathsArray".
     * @see R.path
     * @example
     *
     *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
     *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
     */

    var paths =
    /*#__PURE__*/
    _curry2$1(function paths(pathsArray, obj) {
      return pathsArray.map(function (paths) {
        var val = obj;
        var idx = 0;
        var p;

        while (idx < paths.length) {
          if (val == null) {
            return;
          }

          p = paths[idx];
          val = _isInteger(p) ? nth(p, val) : val[p];
          idx += 1;
        }

        return val;
      });
    });

    /**
     * Retrieve the value at a given path.
     *
     * @func
     * @memberOf R
     * @since v0.2.0
     * @category Object
     * @typedefn Idx = String | Int
     * @sig [Idx] -> {a} -> a | Undefined
     * @param {Array} path The path to use.
     * @param {Object} obj The object to retrieve the nested property from.
     * @return {*} The data at `path`.
     * @see R.prop, R.nth
     * @example
     *
     *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
     *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
     *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
     *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
     */

    var path =
    /*#__PURE__*/
    _curry2$1(function path(pathAr, obj) {
      return paths([pathAr], obj)[0];
    });

    /**
     * Returns a function that when supplied an object returns the indicated
     * property of that object, if it exists.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Object
     * @typedefn Idx = String | Int
     * @sig Idx -> {s: a} -> a | Undefined
     * @param {String|Number} p The property name or array index
     * @param {Object} obj The object to query
     * @return {*} The value at `obj.p`.
     * @see R.path, R.nth
     * @example
     *
     *      R.prop('x', {x: 100}); //=> 100
     *      R.prop('x', {}); //=> undefined
     *      R.prop(0, [100]); //=> 100
     *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
     */

    var prop =
    /*#__PURE__*/
    _curry2$1(function prop(p, obj) {
      return path([p], obj);
    });

    /**
     * Makes a shallow clone of an object, setting or overriding the specified
     * property with the given value. Note that this copies and flattens prototype
     * properties onto the new object as well. All non-primitive properties are
     * copied by reference.
     *
     * @func
     * @memberOf R
     * @since v0.8.0
     * @category Object
     * @sig String -> a -> {k: v} -> {k: v}
     * @param {String} prop The property name to set
     * @param {*} val The new value
     * @param {Object} obj The object to clone
     * @return {Object} A new object equivalent to the original except for the changed property.
     * @see R.dissoc, R.pick
     * @example
     *
     *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
     */

    var assoc =
    /*#__PURE__*/
    _curry3$1(function assoc(prop, val, obj) {
      var result = {};

      for (var p in obj) {
        result[p] = obj[p];
      }

      result[prop] = val;
      return result;
    });

    /**
     * Returns a lens for the given getter and setter functions. The getter "gets"
     * the value of the focus; the setter "sets" the value of the focus. The setter
     * should not mutate the data structure.
     *
     * @func
     * @memberOf R
     * @since v0.8.0
     * @category Object
     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
     * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
     * @param {Function} getter
     * @param {Function} setter
     * @return {Lens}
     * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
     * @example
     *
     *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
     *
     *      R.view(xLens, {x: 1, y: 2});            //=> 1
     *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
     *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
     */

    var lens =
    /*#__PURE__*/
    _curry2$1(function lens(getter, setter) {
      return function (toFunctorFn) {
        return function (target) {
          return map(function (focus) {
            return setter(focus, target);
          }, toFunctorFn(getter(target)));
        };
      };
    });

    /**
     * Returns a lens whose focus is the specified property.
     *
     * @func
     * @memberOf R
     * @since v0.14.0
     * @category Object
     * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
     * @sig String -> Lens s a
     * @param {String} k
     * @return {Lens}
     * @see R.view, R.set, R.over
     * @example
     *
     *      const xLens = R.lensProp('x');
     *
     *      R.view(xLens, {x: 1, y: 2});            //=> 1
     *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
     *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
     */

    var lensProp =
    /*#__PURE__*/
    _curry1$1(function lensProp(k) {
      return lens(prop(k), assoc(k));
    });

    var tracker = function (partical) {
        if (typeof partical === 'function') {
            return function (target, key, descriptor) {
                var value = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var fn = partical.call(this, descriptor.value, this);
                    if (typeof fn === 'function') {
                        //参数为高阶函数
                        return fn.apply(this, args);
                    }
                    else {
                        //普通函数
                        if (typeof fn === 'object') {
                            var data = __assign({}, fn);
                            instance$1.trackEvent(data);
                        }
                        return descriptor.value.apply(this, arguments);
                    }
                };
                // if (descriptor.initializer) {
                //   return propSet('initializer', function() {
                //     const value = descriptor.initializer.apply(this);
                //     return function (...args) {
                //       return partical.call(this, value, this).apply(this, args);
                //     }
                //   }, descriptor);
                // }
                return set_1(lensProp('value'), value, descriptor);
            };
        }
        else if (typeof partical === 'object') {
            return function (target, key, descriptor) {
                var oldValue = descriptor.value;
                descriptor.value = function () {
                    var data = __assign({}, partical);
                    instance$1.trackEvent(data);
                    return oldValue.apply(this, arguments);
                };
                return descriptor;
            };
        }
        else {
            //参数为string 作为tarckId
            return function (target, key, descriptor) {
                var oldValue = descriptor.value;
                descriptor.value = function () {
                    var data = {
                        trackId: partical
                    };
                    instance$1.trackEvent(data);
                    return oldValue.apply(this, arguments);
                };
                return descriptor;
            };
        }
    };

    function _arity$1(n, fn) {
      /* eslint-disable no-unused-vars */
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };

        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };

        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };

        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };

        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };

        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };

        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };

        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };

        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };

        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };

        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };

        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }

    var _arity_1 = _arity$1;

    /**
     * Internal curryN function.
     *
     * @private
     * @category Function
     * @param {Number} length The arity of the curried function.
     * @param {Array} received An array of arguments received thus far.
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */


    function _curryN$1(length, received, fn) {
      return function () {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;

        while (combinedIdx < received.length || argsIdx < arguments.length) {
          var result;

          if (combinedIdx < received.length && (!_isPlaceholder_1(received[combinedIdx]) || argsIdx >= arguments.length)) {
            result = received[combinedIdx];
          } else {
            result = arguments[argsIdx];
            argsIdx += 1;
          }

          combined[combinedIdx] = result;

          if (!_isPlaceholder_1(result)) {
            left -= 1;
          }

          combinedIdx += 1;
        }

        return left <= 0 ? fn.apply(this, combined) : _arity_1(left, _curryN$1(length, combined, fn));
      };
    }

    var _curryN_1 = _curryN$1;

    /**
     * Returns a curried equivalent of the provided function, with the specified
     * arity. The curried function has two unusual capabilities. First, its
     * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
     * following are equivalent:
     *
     *   - `g(1)(2)(3)`
     *   - `g(1)(2, 3)`
     *   - `g(1, 2)(3)`
     *   - `g(1, 2, 3)`
     *
     * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
     * "gaps", allowing partial application of any combination of arguments,
     * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
     * the following are equivalent:
     *
     *   - `g(1, 2, 3)`
     *   - `g(_, 2, 3)(1)`
     *   - `g(_, _, 3)(1)(2)`
     *   - `g(_, _, 3)(1, 2)`
     *   - `g(_, 2)(1)(3)`
     *   - `g(_, 2)(1, 3)`
     *   - `g(_, 2)(_, 3)(1)`
     *
     * @func
     * @memberOf R
     * @since v0.5.0
     * @category Function
     * @sig Number -> (* -> a) -> (* -> a)
     * @param {Number} length The arity for the returned function.
     * @param {Function} fn The function to curry.
     * @return {Function} A new, curried function.
     * @see R.curry
     * @example
     *
     *      const sumArgs = (...args) => R.sum(args);
     *
     *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
     *      const f = curriedAddFourNumbers(1, 2);
     *      const g = f(3);
     *      g(4); //=> 10
     */


    var curryN$1 =
    /*#__PURE__*/
    _curry2_1(function curryN(length, fn) {
      if (length === 1) {
        return _curry1_1(fn);
      }

      return _arity_1(length, _curryN_1(length, [], fn));
    });

    var curryN_1 = curryN$1;

    var before = curryN_1(2, function (trackFn, fn) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (typeof trackFn === 'function') {
                try {
                    var result = trackFn.apply(this, args);
                    if (typeof result === 'object') {
                        instance$1.track(result);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            else if (typeof trackFn === 'object') {
                instance$1.track(trackFn);
            }
            else if (typeof trackFn === 'string') {
                var data = {
                    trackId: trackFn
                };
                instance$1.track(data);
            }
            var evalF = function () {
                var _this = this;
                setTimeout(function () {
                    fn.apply(_this, args);
                }, 300);
            };
            return evalF.apply(this);
        };
    });
    var after = curryN_1(2, function (trackFn, fn) {
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var r = fn.apply(this, args);
            var evalF = function () {
                if (typeof trackFn === 'function') {
                    try {
                        var result = trackFn.apply(_this, args);
                        if (typeof result === 'object') {
                            instance$1.track(result);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else if (typeof trackFn === 'object') {
                    instance$1.track(trackFn);
                }
                else if (typeof trackFn === 'string') {
                    var data = {
                        trackId: trackFn
                    };
                    instance$1.track(data);
                }
            };
            if (isThenable(r)) {
                return r.then(function (rr) {
                    evalF();
                    return rr;
                });
            }
            evalF();
            return r;
        };
    });

    var findIndex = function (arr, callback) {
        for (var i = 0, len = arr.length; i < len; i++) {
            if (callback(arr[i], i)) {
                return i;
            }
        }
        return -1;
    };
    var generate = function (type) {
        var watch = [];
        var track = {
            bind: function (el, binding, vnode) {
                var index = findIndex(watch, function (element) { return element === el; });
                var isWatched = index !== -1;
                if (el.style.display === 'none') {
                    if (!isWatched)
                        watch.push(el);
                    return;
                }
                else {
                    if (isWatched)
                        watch.splice(index, 1);
                }
                if (!isWatched && (notChanged(binding) || isEmpty(binding)))
                    return;
                var info = {};
                if (typeof binding.value === 'object') {
                    info = binding.value;
                    //if (value.pageURL) args.push(value.pageURL)
                }
                else if (typeof binding.value === 'string' && binding.value) {
                    info.trackId = binding.value;
                }
                if (type === 'PAGE') {
                    instance$1.trackPage(info);
                }
                else {
                    instance$1.trackView(el, info);
                }
            },
            unbind: function (el, binding) {
                var index = findIndex(watch, function (element) { return element === el; });
                if (index !== -1)
                    watch.splice(index, 1);
                if (type !== 'PAGE') {
                    var info = {};
                    if (typeof binding.value === 'object') {
                        info = binding.value;
                        //if (value.pageURL) args.push(value.pageURL)
                    }
                    else if (typeof binding.value === 'string' && binding.value) {
                        info.trackId = binding.value;
                    }
                    if (info.trackId) {
                        instance.end(info);
                    }
                }
            },
            update: function (el, binding, vnode) { }
        };
        track.update = track.bind;
        return track;
    };

    var trackView = generate('VIEW');

    function trackEvent (el, binding) {
        if (notChanged(binding) || isEmpty(binding)) {
            return;
        }
        var info = {};
        if (typeof binding.value === 'object' && binding.value) {
            info = binding.value;
        }
        else if (typeof binding.value === 'string') {
            info.trackId = binding.value;
        }
        else if (typeof binding.value === 'number') {
            info.trackId = binding.value + '';
        }
        el._trackerInfo = info;
        el._isWatchTrack = true; //去除自动点击埋点
        var events = Object.keys(binding.modifiers).filter(function (modifier) {
            return binding.modifiers[modifier];
        });
        if (!events.length)
            events.push('click');
        events.forEach(function (event) {
            el.removeEventListener(event, handleEvent, true);
            el.addEventListener(event, handleEvent, true);
        });
    }
    function handleEvent(e) {
        this._trackerInfo.eventName = e.type.toUpperCase();
        if (this.tagName === 'A' && this.href) {
            instance$1.trackLink(this, this._trackerInfo);
        }
        else {
            instance$1.trackDom(this, this._trackerInfo);
        }
    }

    var trackPage = generate('PAGE');

    var trackDom = instance$1.trackDom;
    var trackPage$1 = instance$1.trackPage;
    var trackEvent$1 = instance$1.trackEvent;
    var trackLog = instance$1.trackLog;
    var trackViewStart = instance$1.trackViewStart;
    var trackViewEnd = instance$1.trackViewEnd;
    var trackView$1 = instance$1.trackView;
    var trackLink = instance$1.trackLink;
    var track = instance$1.track;

    if (typeof XMLHttpRequest === 'undefined') {
        throw new Error('tracker requires ie10+');
    }
    try {
        "production";
    }
    catch (e) {
        var g = typeof window !== 'undefined' ? window : global;
        if (typeof g.process === 'undefined')
            g.process = {};
        g.process.env = {};
    }
    if (typeof _TrackerGlobalData === 'undefined') {
        window._TrackerGlobalData = {};
    }

    exports.actionTracker = instance$1;
    exports.after = after;
    exports.before = before;
    exports.getClientInfo = getClientInfo;
    exports.getConfig = getConfig;
    exports.install = install;
    exports.login = login;
    exports.logout = logout;
    exports.send = send;
    exports.sendAsync = sendAsync;
    exports.sendSync = sendSync;
    exports.setConfig = setConfig;
    exports.track = track;
    exports.trackDom = trackDom;
    exports.trackEvent = trackEvent$1;
    exports.trackLink = trackLink;
    exports.trackLog = trackLog;
    exports.trackPage = trackPage$1;
    exports.trackView = trackView$1;
    exports.trackViewEnd = trackViewEnd;
    exports.trackViewStart = trackViewStart;
    exports.tracker = tracker;
    exports.vTrackEvent = trackEvent;
    exports.vTrackPage = trackPage;
    exports.vTrackView = trackView;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=telescope.min.js.map
